// Bahasa Indonesia UI strings. Typed against en so a missing key fails the build.
import type { MessageKey } from './en';

export const id: Record<MessageKey, string> = {
  'common.cancel': 'Batal',
  'common.close': 'Tutup',
  'flow.back_to_builder': 'Kembali ke pembuat',
  'common.reload': 'Muat ulang',
  'common.save': 'Simpan',
  'common.collapse': 'Ciutkan',
  'common.expand': 'Bentangkan',
  'common.add': 'Tambah',
  'common.copy': 'Salin',
  'common.open': 'Buka',
  'common.back': 'Kembali',
  'common.next': 'Lanjut',
  'common.previous': 'Sebelumnya',
  'common.loading': 'Memuat',
  'common.untitled_questionnaire': 'Kuesioner tanpa judul',
  'common.untitled_question': 'Pertanyaan tanpa judul',
  'common.anonymous': 'Anonim',
  'common.required': 'Wajib',
  'common.yes': 'Ya',
  'common.no': 'Tidak',
  'common.action_failed': 'Tindakan gagal.',
  'common.load_failed': 'Gagal memuat.',
  'common.unknown_error': 'Terjadi kesalahan.',

  'lang.label': 'Bahasa',

  'status.draft': 'Draf',
  'status.published': 'Aktif',
  'status.closed': 'Ditutup',
  'status.archived': 'Diarsipkan',

  'role.admin': 'Administrator',
  'role.admin.plural': 'Administrator',
  'role.admin.desc': 'Mengelola pengguna dan dapat mengakses semua kuesioner.',
  'role.creator': 'Peneliti',
  'role.creator.plural': 'Peneliti',
  'role.creator.desc': 'Membuat, mengedit, dan menerbitkan kuesioner miliknya dan yang dibagikan kepadanya.',
  'role.analyst': 'Analis',
  'role.analyst.plural': 'Analis',
  'role.analyst.desc': 'Melihat hasil dan mengekspor data kuesioner yang dibagikan kepadanya.',
  'role.respondent': 'Responden',
  'role.respondent.plural': 'Responden',
  'role.respondent.desc': 'Mengisi survei melalui web dan aplikasi seluler.',
  'role.enumerator': 'Enumerator',
  'role.enumerator.plural': 'Enumerator',
  'role.enumerator.desc': 'Mengumpulkan respons untuk survei yang ditugaskan administrator.',
  'users.manage_roles': 'Ubah peran dan izin',
  'nav.roles': 'Peran & izin',
  'roles.title': 'Peran & izin',
  'roles.sub': 'Setiap peran memberi sekumpulan izin dan menjangkau semua kuesioner atau hanya kuesioner milik pengguna dan yang dibagikan kepadanya. Perubahan langsung berlaku.',
  'roles.assign_link': 'Tetapkan peran ke pengguna',
  'roles.load_failed': 'Tidak dapat memuat peran.',
  'roles.new': 'Peran baru',
  'roles.edit': 'Ubah',
  'roles.edit_title': 'Ubah peran: {name}',
  'roles.delete': 'Hapus',
  'roles.delete_confirm': 'Hapus peran "{name}"?',
  'roles.delete_in_use': 'Pindahkan dulu penggunanya ke peran lain.',
  'roles.deleted': 'Peran dihapus.',
  'roles.created': 'Peran dibuat.',
  'roles.saved': 'Peran disimpan.',
  'roles.save': 'Simpan peran',
  'roles.saving': 'Menyimpan…',
  'roles.key': 'Kunci',
  'roles.key_hint': 'Pengenal tetap: huruf kecil, angka, dan garis bawah, mis. koordinator_lapangan.',
  'roles.name': 'Nama',
  'roles.description': 'Deskripsi',
  'roles.locked': 'Tetap',
  'roles.locked_hint': 'Izin peran ini tetap karena aplikasi bergantung padanya (administrator selalu punya akses penuh; responden dan enumerator bekerja lewat alurnya sendiri). Hanya deskripsi yang dapat diubah.',
  'roles.built_in': 'Bawaan',
  'roles.custom': 'Kustom',
  'roles.scope': 'Jangkauan',
  'roles.scope_all': 'Semua kuesioner',
  'roles.scope_all_hint': 'Izin di bawah berlaku untuk semua kuesioner di workspace.',
  'roles.scope_all_short': 'Semua',
  'roles.scope_shared': 'Kuesioner milik sendiri dan yang dibagikan',
  'roles.scope_shared_hint': 'Kuesioner yang dibuat pengguna atau dibagikan kepadanya sebagai editor atau viewer.',
  'roles.scope_shared_short': 'Milik & dibagikan',
  'roles.permission': 'Izin',
  'roles.permission_count': 'Izin: {count}',
  'roles.user_count': 'Pengguna: {count}',
  'roles.scope_own_flow': 'Hanya alurnya sendiri (tautan publik atau penugasan mobile)',
  'roles.matrix': 'Matriks izin',
  'roles.matrix_sub': 'Apa yang boleh dilakukan setiap peran. Server memeriksa setiap permintaan berdasarkan ini.',
  'roles.allowed': 'Diizinkan',
  'perm.group.surveys': 'Kuesioner',
  'perm.group.fieldwork': 'Lapangan',
  'perm.group.responses': 'Respons',
  'perm.group.administration': 'Administrasi',
  'perm.survey.create': 'Membuat kuesioner',
  'perm.survey.create.hint': 'Memulai kuesioner baru dan menduplikasi yang ada.',
  'perm.survey.view': 'Melihat kuesioner',
  'perm.survey.view.hint': 'Membuka kuesioner dalam jangkauan peran.',
  'perm.survey.edit': 'Mengubah kuesioner',
  'perm.survey.edit.hint': 'Mengubah pertanyaan, logika, dan pengaturan.',
  'perm.survey.publish': 'Memublikasikan kuesioner',
  'perm.survey.publish.hint': 'Memublikasikan versi yang disetujui serta menutup atau membuka kembali pengumpulan.',
  'perm.survey.delete': 'Menghapus dan mengarsipkan kuesioner',
  'perm.survey.delete.hint': 'Mengarsipkan, memulihkan, atau menghapus permanen.',
  'perm.survey.share': 'Membagikan kuesioner',
  'perm.survey.share.hint': 'Memberi pengguna lain akses editor atau viewer.',
  'perm.survey.approve': 'Menyetujui versi kuesioner',
  'perm.survey.approve.hint': 'Menyetujui atau menolak revisi sebelum dapat dipublikasikan.',
  'perm.survey.enumerators.assign': 'Menugaskan enumerator dan responden',
  'perm.survey.enumerators.assign.hint': 'Memilih pengumpul data tiap kuesioner, memetakan responden ke enumerator, dan menjalankan pengacakan kelompok.',
  'perm.respondents.manage': 'Mengelola roster responden',
  'perm.respondents.manage.hint': 'Menambah dan mengoreksi responden bernama, termasuk gender.',
  'perm.responses.view': 'Melihat respons dan hasil',
  'perm.responses.view.hint': 'Dasbor, daftar respons, tabulasi silang.',
  'perm.responses.export': 'Mengekspor respons',
  'perm.responses.export.hint': 'Mengunduh file CSV, Excel, dan SPSS.',
  'perm.responses.approve': 'Menyetujui respons',
  'perm.responses.approve.hint': 'Menyetujui atau menolak respons; ekspor menunggu persetujuan.',
  'perm.users.manage': 'Mengelola pengguna',
  'perm.users.manage.hint': 'Membuat, menonaktifkan, dan mengubah peran pengguna (tidak melebihi izin pengelola sendiri).',
  'perm.audit.view': 'Membaca log audit',
  'perm.audit.view.hint': 'Riwayat masuk dan perubahan di seluruh workspace.',
  'perm.settings.manage': 'Mengelola pengaturan workspace',
  'perm.settings.manage.hint': 'Misalnya menyalakan atau mematikan asisten AI.',
  'perm.library.manage_all': 'Mengelola pertanyaan pustaka semua pengguna',
  'perm.library.manage_all.hint': 'Menghapus item pustaka pertanyaan yang disimpan pengguna lain.',

  'nav.brand_sub': 'Platform kuesioner',
  'nav.new_questionnaire': 'Kuesioner baru',
  'nav.workspace': 'Ruang kerja',
  'nav.questionnaires': 'Kuesioner',
  'nav.administration': 'Administrasi',
  'nav.users_roles': 'Pengguna & peran',
  'nav.audit': 'Log aktivitas',
  'nav.invitations': 'Undangan',
  'nav.settings': 'Pengaturan',
  'a11y.title': 'Aksesibilitas',
  'a11y.summary': '{errors} perlu diperbaiki · {warnings} perlu dipertimbangkan',
  'a11y.all_good': 'Tidak ada masalah',
  'a11y.fix': 'Perbaiki',
  'a11y.consider': 'Pertimbangkan',
  'a11y.open': 'Buka',
  'a11y.wcag_title': 'Kriteria keberhasilan WCAG 2.2 yang terkait',
  'a11y.hint': 'Diperiksa berdasarkan panduan WCAG 2.2 untuk formulir. Pemeriksaan otomatis tidak menangkap semuanya: coba juga kuesioner dengan papan ketik dan pembaca layar.',
  'audit.title': 'Log aktivitas',
  'audit.retention': 'Masuk, penerbitan, persetujuan, ekspor, perubahan respons, serta perubahan pengguna dan berbagi',
  'audit.survey_title': 'Aktivitas',
  'audit.survey_sub': 'Siapa yang mengubah, menerbitkan, menyetujui, atau mengekspor kuesioner ini',
  'audit.all_actions': 'Semua aktivitas',
  'audit.filter_action': 'Jenis aktivitas',
  'audit.filter_actor': 'Cari berdasarkan orang',
  'audit.empty': 'Belum ada aktivitas',
  'audit.when': 'Waktu',
  'audit.who': 'Siapa',
  'audit.what': 'Apa',
  'audit.questionnaire': 'Kuesioner',
  'audit.details': 'Detail',
  'audit.more': 'Tampilkan {count} lagi',
  'audit.group.auth': 'Masuk',
  'audit.group.survey': 'Kuesioner',
  'audit.group.response': 'Respons',
  'audit.group.user': 'Pengguna',
  'audit.group.library': 'Pustaka pertanyaan',
  'audit.group.respondent': 'Roster responden',
  'audit.group.account': 'Akun sendiri',
  'audit.auth.login': 'Masuk',
  'audit.auth.login_failed': 'Gagal masuk',
  'audit.auth.register': 'Membuat akun',
  'audit.account.update': 'Memperbarui profil',
  'audit.account.password_change': 'Mengganti kata sandi',
  'audit.user.create': 'Membuat pengguna',
  'audit.user.update': 'Mengubah pengguna',
  'audit.settings.update': 'Mengubah pengaturan ruang kerja',
  'audit.survey.create': 'Membuat kuesioner',
  'audit.survey.publish': 'Menerbitkan',
  'audit.survey.approval': 'Meninjau untuk diterbitkan',
  'audit.survey.closed': 'Menutup respons',
  'audit.survey.slug': 'Mengubah tautan khusus',
  'audit.survey.auto_close': 'Ditutup otomatis',
  'audit.survey.collection': 'Mengubah jadwal & batas',
  'audit.survey.invites_add': 'Menambah undangan responden',
  'audit.survey.invites_send': 'Mengirim undangan',
  'audit.survey.invites_remind': 'Mengirim pengingat',
  'audit.survey.invites_remove': 'Menghapus undangan',
  'audit.survey.archived': 'Mengarsipkan',
  'audit.survey.restore': 'Memulihkan',
  'audit.survey.duplicate': 'Menduplikasi',
  'audit.survey.delete': 'Menghapus kuesioner',
  'audit.survey.share': 'Membagikan',
  'audit.survey.unshare': 'Berhenti membagikan',
  'audit.survey.enumerators': 'Menugaskan enumerator',
  'audit.survey.respondent_assignments': 'Menugaskan responden',
  'audit.survey.group_randomize': 'Mengacak grup',
  'audit.survey.weighting': 'Mengubah pembobotan',
  'audit.response.approval': 'Meninjau respons',
  'audit.response.edit': 'Mengubah respons',
  'audit.response.sync': 'Mengunggah respons dari aplikasi mobile',
  'audit.response.sync_rejected': 'Unggahan mobile ditolak',
  'audit.responses.export': 'Mengekspor respons',
  'audit.responses.test_create': 'Membuat respons uji',
  'audit.responses.test_delete': 'Menghapus respons uji',
  'audit.library.save': 'Menyimpan ke pustaka pertanyaan',
  'audit.library.delete': 'Menghapus dari pustaka pertanyaan',
  'audit.respondent.create': 'Menambah responden',
  'audit.respondent.update': 'Mengubah responden',
  'nav.respondents': 'Daftar responden',
  'nav.account_settings': 'Pengaturan akun',
  'nav.light_mode': 'Mode terang',
  'nav.dark_mode': 'Mode gelap',
  'nav.switch_light': 'Beralih ke mode terang',
  'nav.switch_dark': 'Beralih ke mode gelap',
  'nav.sign_out': 'Keluar',
  'nav.open_navigation': 'Buka navigasi',
  'nav.collapse_sidebar': 'Ciutkan sidebar menjadi ikon',
  'nav.expand_sidebar': 'Bentangkan sidebar',
  'nav.breadcrumb': 'Jejak navigasi',
  'nav.main': 'Utama',

  'auth.welcome_back': 'Selamat datang kembali',
  'auth.signin_sub': 'Masuk untuk mengelola kuesioner dan respons.',
  'auth.email': 'Email',
  'auth.password': 'Kata sandi',
  'auth.name': 'Nama',
  'auth.sign_in': 'Masuk',
  'auth.signing_in': 'Sedang masuk…',
  'auth.no_account': 'Belum punya akun?',
  'auth.create_one': 'Buat akun',
  'auth.signin_failed': 'Gagal masuk.',
  'auth.create_title': 'Buat akun',
  'auth.create_sub': 'Isi survei yang mewajibkan masuk. Administrator dapat memberikan akses tambahan nanti.',
  'auth.password_hint': 'Minimal 8 karakter.',
  'auth.creating': 'Membuat…',
  'auth.create_account': 'Buat akun',
  'auth.already_registered': 'Sudah terdaftar?',
  'auth.register_failed': 'Pendaftaran gagal.',
  'auth.invite_sub': 'Anda diundang bergabung sebagai {role}. Administrator menyetujui setiap pendaftaran sebelum Anda bisa masuk.',
  'auth.invite_checking': 'Memeriksa undangan Anda…',
  'auth.invite_invalid': 'Link undangan ini tidak valid, sudah dicabut, atau kuotanya habis. Minta link baru ke pengirimnya.',
  'auth.signup_sent_title': 'Pendaftaran terkirim',
  'auth.signup_sent_body': 'Terima kasih! Administrator akan meninjau pendaftaran Anda. Anda bisa masuk setelah disetujui.',
  'auth.back_to_signin': 'Kembali ke halaman masuk',
  'auth.show_password': 'Tampilkan kata sandi',
  'auth.hide_password': 'Sembunyikan kata sandi',
  'auth.remember_me': 'Ingat saya',
  'auth.remember_hint': 'Tetap masuk di perangkat ini. Kosongkan jika memakai komputer bersama.',

  'error.network': 'Tidak dapat terhubung ke server. Periksa koneksi Anda lalu coba lagi.',
  'error.request_failed': 'Permintaan gagal ({status})',

  'time.just_now': 'baru saja',
  'time.min_ago': '{n} mnt lalu',
  'time.hours_ago': '{n} jam lalu',
  'time.days_ago': '{n} hari lalu',
  'dur.seconds': '{s} dtk',
  'dur.min_sec': '{m} mnt {s} dtk',
  'dur.min': '{m} mnt',
  'dur.hour_min': '{h} jam {m} mnt',

  'surveys.title': 'Kuesioner',
  'surveys.new': 'Baru',
  'surveys.kpi_total': 'Kuesioner',
  'surveys.kpi_live': 'Sedang aktif',
  'surveys.kpi_drafts': 'Draf',
  'surveys.kpi_responses': 'Respons',
  'surveys.filter_all': 'Semua aktif',
  'surveys.filter_drafts': 'Draf',
  'surveys.filter_live': 'Aktif',
  'surveys.filter_closed': 'Ditutup',
  'surveys.filter_archived': 'Diarsipkan',
  'surveys.search_placeholder': 'Cari judul, nomor, atau kode',
  'surveys.search_label': 'Cari kuesioner',
  'surveys.load_failed': 'Gagal memuat kuesioner.',
  'surveys.no_matches': 'Tidak ada hasil',
  'surveys.none_yet': 'Belum ada kuesioner',
  'surveys.create_first': 'Buat kuesioner pertama Anda',
  'surveys.try_other_filter': 'Coba filter atau kata kunci lain.',
  'surveys.col_no': 'No.',
  'surveys.col_questionnaire': 'Kuesioner',
  'surveys.col_code': 'Kode',
  'surveys.col_status': 'Status',
  'surveys.col_owner': 'Pemilik',
  'surveys.col_responses': 'Respons',
  'surveys.col_updated': 'Diperbarui',
  'surveys.col_actions': 'Tindakan',
  'surveys.toggle_summary': 'Tampilkan atau sembunyikan ringkasan',
  'surveys.group_by_status': 'Kelompokkan per status',
  'surveys.toggle_group': 'Tampilkan atau sembunyikan {status}',
  'surveys.shared_with_you': 'Dibagikan kepada Anda · {relation}',
  'surveys.actions_for': 'Tindakan untuk {title}',
  'surveys.edit': 'Edit',
  'surveys.responses': 'Respons',
  'surveys.duplicate': 'Duplikat',
  'surveys.archive': 'Arsipkan',
  'surveys.restore': 'Pulihkan',
  'surveys.delete': 'Hapus',
  'surveys.duplicated': 'Kuesioner diduplikat',
  'surveys.archived': 'Diarsipkan',
  'surveys.restored': 'Dipulihkan',
  'surveys.deleted': 'Dihapus',
  'surveys.confirm_delete': 'Hapus “{title}”? Tindakan ini tidak dapat dibatalkan.',
  'surveys.confirm_delete_with_responses': 'Hapus “{title}” beserta {count} responsnya? Tindakan ini tidak dapat dibatalkan.',
  'relation.owner': 'pemilik',
  'relation.editor': 'editor',
  'relation.viewer': 'peninjau',
  'relation.admin': 'admin',

  'new.title': 'Kuesioner baru',
  'new.title_label': 'Judul',
  'new.title_hint': 'Dapat diubah nanti.',
  'new.title_placeholder': 'mis. Kepuasan pelanggan Q4',
  'new.start_from': 'Mulai dari',
  'new.blank': 'Kosong',
  'new.blank_text': 'Kuesioner kosong.',
  'new.starter': 'Contoh awal',
  'new.starter_text': 'Empat pertanyaan dengan satu kondisi dan opsi acak.',
  'new.create': 'Buat dan buka pembuat kuesioner',
  'new.failed': 'Gagal membuat kuesioner.',
  'starter.welcome': 'Terima kasih telah meluangkan waktu untuk membantu kami menjadi lebih baik.',
  'starter.thanks': 'Respons Anda telah tercatat. Terima kasih!',
  'starter.q1': 'Seberapa puas Anda dengan layanan kami?',
  'starter.q1_min': 'Sangat tidak puas',
  'starter.q1_max': 'Sangat puas',
  'starter.q2': 'Apa yang bisa kami tingkatkan?',
  'starter.q3': 'Dari mana Anda mengetahui kami?',
  'starter.q3_o1': 'Mesin pencari',
  'starter.q3_o2': 'Teman atau rekan kerja',
  'starter.q3_o3': 'Media sosial',
  'starter.q3_o4': 'Lainnya',
  'starter.q4': 'Apakah Anda akan merekomendasikan kami kepada teman?',

  'tabs.build': 'Susun',
  'tabs.settings': 'Pengaturan',
  'tabs.preview': 'Pratinjau',
  'tabs.share': 'Terbitkan & bagikan',
  'tabs.responses': 'Respons',
  'header.code_title': 'Kode unik kuesioner',

  'builder.load_failed': 'Gagal memuat kuesioner.',
  'builder.undo': 'Urungkan',
  'builder.redo': 'Ulangi',
  'builder.title_label': 'Judul kuesioner',
  'builder.publish': 'Terbitkan',
  'builder.publish_changes': 'Terbitkan perubahan',
  'builder.published': 'Sudah terbit',
  'builder.reopen': 'Buka kembali',
  'builder.issues_before_publish': '{count} masalah perlu diperbaiki sebelum diterbitkan',
  'builder.issues_before_publish_one': '1 masalah perlu diperbaiki sebelum diterbitkan',
  'builder.conflict': 'Kuesioner ini diubah di tab lain atau oleh rekan tim. Perubahan terakhir Anda belum tersimpan.',
  'builder.load_latest': 'Muat versi terbaru',
  'builder.questions': 'Pertanyaan',
  'builder.collapse_panel': 'Ciutkan panel menjadi ikon',
  'builder.expand_panel': 'Bentangkan panel',
  'builder.resize_panel': 'Geser untuk mengatur lebar panel — klik dua kali untuk mengatur ulang',
  'builder.total': '{count} total',
  'builder.has_logic': 'Memiliki logika tampilan',
  'builder.needs_attention': 'Perlu diperbaiki',
  'builder.no_questions': 'Belum ada pertanyaan.',
  'builder.add_first': 'Tambahkan pertanyaan pertama',
  'builder.add_first_hint': 'Pilih jenis pertanyaan untuk mulai menyusun.',
  'builder.add_question': 'Tambah pertanyaan',
  'builder.add_a_question': 'Tambah pertanyaan',
  'builder.confirm_delete': 'Hapus pertanyaan ini?',
  'builder.confirm_delete_deps': 'Hapus pertanyaan ini? {count} pertanyaan lain menggunakannya dalam logika tampilan; kondisi tersebut akan dihapus.',
  'builder.confirm_delete_deps_one': 'Hapus pertanyaan ini? 1 pertanyaan lain menggunakannya dalam logika tampilan; kondisi tersebut akan dihapus.',
  'builder.published_version': 'Versi {version} diterbitkan',
  'builder.responses_closed': 'Pengumpulan respons ditutup',
  'builder.settings': 'Pengaturan',
  'builder.shuffle': 'Pengacakan',
  'builder.shuffle.off': 'Mati — ikuti urutan yang ditulis',
  'builder.shuffle.questions': 'Pertanyaan di dalam setiap bagian',
  'builder.shuffle.sections': 'Urutan bagian',
  'builder.shuffle.both': 'Urutan bagian dan pertanyaan di dalam bagian',
  'builder.shuffle.hint': 'Setiap responden mendapat urutan sendiri. Atur tiap bagian di bawah, mis. bagian pertama tetap dan bagian lainnya diacak.',
  'builder.section_shuffle': 'Pengacakan per bagian',
  'builder.untitled_section': 'Tanpa bagian',
  'builder.shuffle_questions_here': 'Acak pertanyaan',
  'builder.can_move': 'Bisa berpindah',
  'builder.pinned_untitled': 'Pertanyaan tanpa bagian tetap di posisinya.',
  'builder.pinned_logic': 'Tetap di posisinya: terhubung dengan logika tampilan atau lompatan.',
  'builder.outline_view': 'Daftar menampilkan',
  'builder.outline_titles': 'Judul',
  'builder.outline_codes': 'Kode',
  'builder.outline_no_code': 'Tanpa kode',
  'builder.outline_preview': 'Pratinjau',
  'builder.preview_mode_hint': 'Lihat setiap pertanyaan seperti responden dan ubah langsung di tempat',
  'builder.side_tabs': "Kerangka dan pertanyaan terpilih",
  'builder.side_outline': "Kerangka",
  'builder.side_selected': "Pertanyaan terpilih",
  'all.pick_question': 'Klik pertanyaan untuk mengubah pengaturan lainnya di sini.',
  'builder.group_sections': 'Kelompokkan per bagian',
  'builder.section_count': '{count} pertanyaan',
  'builder.section_count_one': '1 pertanyaan',
  'builder.toggle_section': 'Tampilkan atau sembunyikan bagian {title}',
  'builder.view_flow': 'Lihat alur survei',
  'builder.flow_title': 'Alur survei',
  'builder.add_section': 'Tambah bagian',
  'builder.rename_section': 'Ganti nama bagian',
  'builder.group_into_section': 'Kelompokkan pertanyaan yang ada ke dalam bagian…',
  'builder.question_needs_section': 'Buat bagian terlebih dahulu: setiap pertanyaan harus berada dalam suatu bagian.',
  'builder.add_to_section': 'Tambahkan ke bagian',
  'builder.add_first_section_hint': 'Pertanyaan berada dalam bagian. Buat bagian pertama Anda, lalu tambahkan pertanyaan ke dalamnya.',
  'builder.drag_section': 'Seret untuk memindahkan bagian ini',
  'builder.leads_to': '{count} pertanyaan lain bereaksi terhadap jawaban ini',
  'flow.drag_randomizer': 'Seret untuk memindahkan pengacak ini',
  'builder.in_randomizer': 'Pengacak: setiap responden melihat {present} dari {total} bagian',
  'builder.remove_section': 'Hapus bagian',
  'builder.confirm_remove_section': 'Hapus bagian “{title}”? Pertanyaannya tetap di tempatnya.',
  'builder.section_name': 'Nama bagian',
  'builder.section_starts_at': 'Mulai dari pertanyaan',
  'builder.section_starts_hint': 'Pertanyaan ini dan pertanyaan berikutnya di bagian yang sama akan masuk ke bagian baru.',
  'builder.sections_total': '{count} bagian',
  'builder.sections_total_one': '1 bagian',
  'builder.outline_search': 'Cari pertanyaan…',
  'builder.outline_matches': '{count} dari {total} pertanyaan',
  'builder.outline_no_match': 'Tidak ada pertanyaan yang cocok.',
  'builder.clear_filters': 'Hapus filter',
  'builder.view_options': 'Opsi tampilan',
  'builder.sections_label': 'Bagian',
  'builder.filter': 'Saring pertanyaan',
  'builder.filter.all': 'Semua',
  'builder.filter.logic': 'Logika',
  'builder.filter.issues': 'Perlu dicek',
  'builder.filter.required': 'Wajib',
  'builder.expand_all': 'Buka semua bagian',
  'builder.collapse_all': 'Tutup semua bagian',
  'builder.shuffle_on': 'Diacak',
  'builder.login_required': 'Wajib masuk',
  'builder.allow_back': "Responden boleh kembali",
  'builder.allow_back_on': "Tombol Kembali memungkinkan responden kembali ke pertanyaan sebelumnya dan mengubah jawabannya.",
  'builder.allow_back_off': "Tanpa tombol Kembali: halaman yang sudah dijawab tidak bisa direvisi.",
  'flow.ov_moving': "Alur pengisian",
  'builder.show_progress': 'Tampilkan bilah kemajuan',
  'builder.show_timer': 'Tampilkan pengukur waktu kepada responden',
  'builder.captcha': 'Verifikasi manusia (captcha)',
  'builder.captcha.end': 'Sebelum mengirim',
  'builder.captcha.start': 'Di awal',
  'builder.captcha.both': 'Di awal dan sebelum mengirim',
  'builder.captcha.hint': 'Tempat responden melihat kotak "Verify you are human" dari Cloudflare di tautan web. Setiap pengiriman tetap diperiksa; aplikasi mobile tidak terpengaruh.',
  'builder.page_mode': 'Tata letak halaman',
  'builder.page_mode.question': 'Satu pertanyaan per halaman',
  'builder.page_mode.section': 'Satu bagian per halaman',
  'builder.page_mode.all': 'Semua pertanyaan dalam satu halaman',
  'builder.page_mode.question.hint': 'Responden melihat satu pertanyaan setiap kali.',
  'builder.page_mode.section.hint': 'Pertanyaan berurutan dengan judul bagian yang sama ditampilkan dalam satu halaman. Pertanyaan tanpa judul bagian mendapat halaman sendiri.',
  'builder.page_mode.all.hint': 'Semua pertanyaan tampil dalam satu halaman yang dapat digulir. Pertanyaan bersyarat langsung muncul saat berlaku.',
  'builder.require_auth': 'Wajibkan responden masuk',
  'builder.description': 'Deskripsi',
  'builder.welcome_message': 'Pesan pembuka',
  'builder.thankyou_message': 'Pesan terima kasih',
  'settings.endings': 'Akhir survei',
  'settings.no_endings': 'Belum ada akhir tambahan. Semua responden melihat pesan terima kasih.',
  'settings.ending_n': 'Akhir {n}',
  'settings.ending_name': 'Nama (hanya terlihat oleh Anda)',
  'settings.ending_message': 'Pesan yang dilihat responden',
  'settings.redirect': 'Tautan pengalihan',
  'settings.redirect_placeholder': 'Opsional: arahkan responden ke tautan https setelahnya',
  'settings.remove_ending': 'Hapus akhir survei',
  'settings.used_by': 'Dipakai {count} aturan lompat',
  'settings.used_by_one': 'Dipakai 1 aturan lompat',
  'settings.endings_hint': 'Arahkan aturan lompat pertanyaan ke akhir survei untuk berhenti di sana. Jawaban sejauh itu tetap tersimpan.',
  'settings.quotas': 'Kuota',
  'settings.no_quotas': 'Belum ada kuota. Semua respons diterima.',
  'settings.quota_n': 'Kuota {n}',
  'settings.quota_name': 'Nama kuota',
  'settings.quota_limit': 'Batas',
  'settings.quota_count': '{n} / {limit}',
  'settings.quota_count_title': 'Respons yang sudah terhitung',
  'settings.quota_counts_when': 'Menghitung respons yang memenuhi',
  'settings.quota_message': 'Pesan untuk responden yang tersaring (opsional)',
  'settings.remove_quota': 'Hapus kuota',
  'settings.quotas_hint': 'Saat kuota penuh, responden web yang memenuhinya akan dihentikan dengan ucapan terima kasih; jawabannya tidak disimpan. Wawancara lapangan dari aplikasi selalu disimpan.',
  'settings.hidden_fields': 'Kolom tersembunyi',
  'settings.field_name': 'Nama kolom',
  'settings.field_placeholder': 'mis. region atau source',
  'settings.remove_field': 'Hapus {name}',
  'settings.hidden_fields_hint': 'Tambahkan kolom ke tautan sebagai ?name=nilai (ganti name dengan nama kolom). Nilainya tersimpan bersama respons, muncul di ekspor, dan dapat ditampilkan di pertanyaan dengan {{name}}.',
  'settings.loops': 'Perulangan',
  'settings.loops_need_sections': 'Beri judul bagian pada pertanyaan terlebih dahulu; setelah itu bagian dapat diulang.',
  'settings.loop_none': 'Jangan ulangi',
  'settings.loop_no_source': 'Tambahkan pertanyaan pilihan ganda sebelum bagian ini untuk diulang',
  'settings.loop_for_each': 'Ulangi untuk setiap opsi yang dipilih di {n}. {title}',
  'settings.loops_hint': 'Pertanyaan di bagian yang berulang ditanyakan sekali untuk setiap opsi yang dipilih. Gunakan {{loop}} di teks pertanyaan untuk menampilkan opsinya.',
  'settings.theme': 'Tampilan',
  'settings.theme_primary': 'Warna aksen',
  'settings.theme_background': 'Latar halaman',
  'settings.theme_default': 'Bawaan',
  'settings.theme_reset': 'Gunakan bawaan',
  'settings.theme_font': 'Huruf',
  'settings.font_system': 'Standar',
  'settings.theme_zoom': 'Ukuran tampilan',
  'settings.theme_zoom_hint': 'Membuat kuesioner lebih besar atau lebih kecil bagi responden, misalnya di tablet atau layar besar.',
  'settings.zoom_standard': 'Standar (100%)',
  'settings.font_serif': 'Serif',
  'settings.font_rounded': 'Membulat',
  'settings.font_mono': 'Monospace',
  'settings.theme_logo': 'Logo',
  'settings.logo_hint': 'Ditampilkan di bagian atas kuesioner',
  'settings.logo_set': 'Logo ditambahkan',
  'settings.theme_preview': 'Pratinjau warna aksen dan latar',
  'settings.languages': 'Bahasa',
  'settings.base_language': 'Kuesioner ditulis dalam',
  'settings.base_language_hint': 'Responden yang memilih bahasa lain melihat teks ini jika terjemahan belum ada.',
  'settings.add_language': 'Tambah bahasa',
  'settings.choose_language': 'Pilih bahasa…',
  'settings.edit_translation': 'Terjemahkan',
  'settings.remove_language': 'Hapus {name}',
  'settings.translated': '{n} dari {total} diterjemahkan',
  'settings.languages_hint': 'Responden memilih bahasa di halaman pertama; pilihannya tersimpan bersama respons.',
  'tr.modal_title': 'Terjemahkan ke {name}',
  'tr.only_missing': 'Hanya yang belum diterjemahkan',
  'tr.all_done': 'Semua sudah diterjemahkan.',
  'tr.survey': 'Kuesioner',
  'tr.title': 'Judul',
  'tr.description': 'Deskripsi',
  'tr.sections': 'Bagian',
  'tr.section': 'Bagian',
  'tr.question': 'Pertanyaan',
  'save.saving': 'Menyimpan…',
  'save.error': 'Belum tersimpan — mencoba lagi.',
  'save.retry_now': 'Coba sekarang',
  'save.conflict': 'Konflik',
  'save.saved_ago': 'Tersimpan {ago}',
  'save.all_saved': 'Semua perubahan tersimpan',

  'qe.question_n': 'Pertanyaan {n}',
  'qe.move_up': 'Pindah ke atas',
  'qe.move_down': 'Pindah ke bawah',
  'qe.duplicate': 'Duplikat pertanyaan',
  'qe.duplicate_short': 'Duplikat',
  'qe.delete': 'Hapus pertanyaan',
  'qe.delete_short': 'Hapus',
  'qe.question': 'Pertanyaan',
  'qe.question_code': 'Kode pertanyaan (opsional)',
  'qe.question_code_hint': 'Huruf, angka, tanda hubung, atau garis bawah; harus unik dalam kuesioner ini.',
  'qe.question_code_placeholder': 'mis. RT-01',
  'qe.section_placeholder': 'mis. Informasi rumah tangga',
  'qe.question_placeholder': 'Apa yang ingin Anda tanyakan?',
  'qe.type': 'Jenis',
  'qe.change_type': 'Ubah jenis pertanyaan',
  'qe.change_type_hint': 'Judul, kode, bagian, tooltip, dan logika tetap tersimpan. Pilihan jawaban hanya dipertahankan jika berpindah antar jenis pilihan.',
  'qe.text_align': "Perataan teks",
  'qe.help_text': 'Teks bantuan (opsional)',
  'qe.help_placeholder': 'Panduan tambahan yang tampil di bawah pertanyaan',
  'qe.tooltip': 'Tooltip info (opsional)',
  'qe.tooltip_hint': 'Ditampilkan di balik ikon ⓘ di samping judul pertanyaan. {used}/{max}',
  'qe.tooltip_placeholder': 'mis. Definisi, satuan, atau tempat menemukan jawabannya',
  // media pertanyaan
  'media.title': 'Gambar atau video (opsional)',
  'media.upload_image': 'Unggah gambar',
  'media.upload_video': 'Unggah video',
  'media.uploading': 'Mengunggah…',
  'media.link': 'Tautan gambar atau video',
  'media.link_placeholder': 'Tempel tautan YouTube, Vimeo, atau https://',
  'media.add_link': 'Tambah tautan',
  'media.hint': 'Gambar maksimal {image} MB (JPG, PNG, WebP, GIF). Video maksimal {video} MB (MP4, WebM, MOV), atau tautan YouTube/Vimeo.',
  'media.alt': 'Deskripsi gambar',
  'media.alt_placeholder': 'Jelaskan gambar untuk pembaca layar',
  'media.caption': 'Keterangan',
  'media.caption_placeholder': 'Teks opsional di bawah video',
  'media.autoplay': 'Putar otomatis',
  'media.muted': 'Mulai tanpa suara',
  'media.autoplay_hint': 'Sebagian besar browser hanya memutar otomatis video tanpa suara. Jika suara diblokir, video dimulai tanpa suara.',
  'media.remove_image': 'Hapus gambar',
  'media.remove_video': 'Hapus video',
  'media.add_option_image': 'Tambah gambar',
  'media.add_option_image_n': 'Tambah gambar ke {label}',
  'media.remove_option_image': 'Hapus gambar',
  'media.remove_option_image_n': 'Hapus gambar dari {label}',
  'media.too_large_file': "“{name}” berukuran {size} MB. Ukuran maksimal {max} MB. Perpendek atau kompres videonya, atau tempel tautan YouTube atau Vimeo.",
  'media.uploading_file': "Mengunggah “{name}”…",
  'error.upload_too_large': "Berkas lebih besar dari yang diterima server. Coba berkas yang lebih kecil atau tautan YouTube/Vimeo.",
  'media.too_large': 'Berkas terlalu besar (maks. {max} MB).',
  'media.wrong_kind': 'Jenis berkas tidak sesuai. Pilih gambar untuk gambar dan video untuk video.',
  'media.upload_failed': 'Gagal mengunggah. Coba lagi.',
  'media.video': 'Video',
  'media.play': 'Putar',
  'media.pause': 'Jeda',
  'media.rewind': 'Mundur 10 dtk',
  'media.stop': 'Berhenti',
  'media.mute': 'Bisukan',
  'media.unmute': 'Bunyikan',
  'qe.required': 'Wajib',
  'qe.options': 'Opsi',
  'qe.option_n': 'Opsi {n}',
  'qe.pinned': 'Tetap di posisinya saat diacak',
  'qe.pin': 'Kunci posisi saat diacak',
  'qe.unpin_option': 'Lepas kunci opsi',
  'qe.pin_option': 'Kunci opsi',
  'qe.remove_option': 'Hapus opsi {n}',
  'qe.add_option': 'Tambah opsi',
  'qe.shuffle_options': 'Acak urutan opsi',
  'qe.text': 'Teks',
  'qe.columns': 'Kolom jawaban',
  'qe.rows': 'Pernyataan (baris)',
  'qe.items': 'Item',
  'qe.fields': 'Kolom isian',
  'qe.column_n': 'Kolom {n}',
  'qe.row_n': 'Pernyataan {n}',
  'qe.item_n': 'Item {n}',
  'qe.field_n': 'Isian {n}',
  'qe.add_column': 'Tambah kolom',
  'qe.add_row': 'Tambah pernyataan',
  'qe.add_item': 'Tambah item',
  'qe.add_field': 'Tambah isian',
  'qe.add_other': 'Tambah “Lainnya, sebutkan”',
  'qe.other_label': 'Lainnya',
  'qe.other_badge': 'minta teks',
  'qe.shuffle_rows': 'Acak pernyataan',
  'qe.matrix_multiple': 'Izinkan beberapa jawaban per pernyataan',
  'qe.assign_points': 'Beri poin',
  'qe.points': 'Poin',
  'qe.points_for': 'Poin untuk {label}',
  'qe.agree_1': 'Sangat tidak setuju',
  'qe.agree_2': 'Tidak setuju',
  'qe.agree_3': 'Netral',
  'qe.agree_4': 'Setuju',
  'qe.agree_5': 'Sangat setuju',
  'qe.step': 'Langkah',
  'qe.total': 'Harus berjumlah',
  'qe.total_hint': 'Responden membagi jumlah ini ke item-item, mis. 100 untuk persentase.',
  'qe.options_from': 'Opsi',
  'qe.options_written': 'Ditulis di sini',
  'qe.carry_selected': 'Opsi yang dipilih di pertanyaan {n}',
  'qe.carry_not_selected': 'Opsi yang tidak dipilih di pertanyaan {n}',
  'qe.carry_hint': 'Responden melihat opsi dari pertanyaan tersebut. Jika tidak ada, pertanyaan ini dilewati.',
  'qe.pipe': 'Sisipkan jawaban',
  'qe.pipe_answers': 'Jawaban dari',
  'qe.pipe_fields': 'Kolom tersembunyi',
  'qe.pipe_loop': 'Opsi perulangan saat ini',
  'qe.pipe_score': 'Skor sejauh ini',
  'qe.about_file_upload': 'Responden mengunggah satu foto atau dokumen (maks. 10 MB). Berkas hanya dapat dilihat oleh yang berhak melihat respons.',
  'qe.about_signature': 'Responden menggambar tanda tangan dengan jari, pena, atau tetikus.',
  'qe.about_location': 'Responden membagikan lokasi GPS. Peramban atau ponsel akan meminta izin terlebih dahulu.',
  'qe.about_descriptive': 'Hanya menampilkan teks dan media; tidak ada jawaban yang disimpan.',
  'library.save': 'Simpan ke pustaka pertanyaan',
  'library.tab_new': 'Pertanyaan baru',
  'library.tab_library': 'Pustaka pertanyaan',
  'library.tab_copy': 'Dari kuesioner lain',
  'library.search': 'Cari pertanyaan tersimpan',
  'library.empty': 'Pustaka masih kosong',
  'library.no_match': 'Tidak ada pertanyaan tersimpan yang cocok',
  'library.empty_hint': 'Simpan pertanyaan dengan tombol penanda di editor pertanyaan agar dapat dipakai ulang di kuesioner mana pun.',
  'library.saved_by': 'disimpan oleh {name}',
  'library.remove': 'Hapus dari pustaka',
  'library.saved': 'Tersimpan di pustaka pertanyaan.',
  'library.pick_survey': 'Pilih kuesioner…',
  'library.copy_hint': 'Salinan mempertahankan teks, opsi, dan pengaturan. Logika tampilan dan aturan lompat tidak ikut disalin.',
  'library.select_all': 'Pilih semua',
  'library.select_none': 'Batalkan pilihan',
  'library.copy_n': 'Salin {count} pertanyaan',
  'library.copy_n_one': 'Salin 1 pertanyaan',
  'qe.scale': 'Skala',
  'qe.scale_min': 'Skala minimum',
  'qe.scale_max': 'Skala maksimum',
  'qe.to': 'sampai',
  'qe.low_label': 'Label terendah',
  'qe.low_placeholder': 'mis. Buruk',
  'qe.high_label': 'Label tertinggi',
  'qe.high_placeholder': 'mis. Sangat baik',
  'qe.minimum': 'Minimum',
  'qe.maximum': 'Maksimum',
  'qe.whole_numbers': 'Hanya bilangan bulat',
  'qe.min_length': 'Panjang minimum',
  'qe.max_length': 'Panjang maksimum',
  'qe.placeholder': 'Teks contoh',
  'qe.min_selections': 'Pilihan minimum',
  'qe.max_selections': 'Pilihan maksimum',
  'qe.display_logic': 'Logika tampilan',
  'qe.display_logic_sub': 'Lewati pertanyaan ini kecuali jawaban sebelumnya sesuai',
  'qe.randomization': 'Pengacakan',
  'qe.randomization_sub': 'Urutan pertanyaan diacak untuk setiap responden',
  'qe.randomization_sub_off': 'Pengacakan nonaktif: pertanyaan tampil sesuai urutan yang ditulis',
  'qe.keep_position': 'Jangan acak pertanyaan ini (tetap di posisinya)',
  'qe.keep_position_on': 'Aktif: pertanyaan ini selalu tetap di posisinya, meskipun pertanyaan lain diacak.',
  'qe.keep_position_off': 'Nonaktif: pertanyaan ini ikut diacak bersama pertanyaan lain di bagiannya.',
  'qe.pinned_by_logic': 'Terkunci otomatis: pertanyaan yang terhubung dengan logika tampilan tetap pada urutannya agar kondisi selalu muncul setelah sumbernya.',

  'logic.first_always': 'Pertanyaan pertama selalu ditampilkan. Tambahkan logika pada pertanyaan berikutnya untuk melewatinya berdasarkan jawaban sebelumnya.',
  'qe.logic_leads': 'Logika yang memakai pertanyaan ini',
  'qe.logic_leads_sub': 'Pertanyaan lain bereaksi terhadap jawaban di sini.',
  'qe.logic_shows': 'Jika jawabannya {cond}, menampilkan',
  'qe.logic_carries': 'Membawa pilihan ini ke',
  'qe.logic_go': 'Buka {q}',
  'qe.shuffle_off_hint': 'Pengacakan nonaktif untuk kuesioner ini. Opsi ini berlaku setelah Anda mengaktifkannya di Pengaturan.',
  'qe.randomizer_member': 'Bagian ini ada dalam pengacak: setiap responden melihat {present} dari {total} bagian.',
  'qe.edit_in_flow': 'Ubah di alur survei',
  'qe.shuffle_with_logic': 'Acak pertanyaan ini meskipun memiliki logika',
  'qe.shuffle_with_logic_hint': 'Tetap muncul setelah pertanyaan yang dibaca kondisinya, sehingga logika tetap berfungsi.',
  'logic.route_sub': "Percabangan: pilih ke mana tiap jawaban mengarah, mis. “Ayam” → P3",
  'logic.route_count': "{count} rute",
  'logic.route_title': 'Arahkan setiap jawaban ke pertanyaan',
  'logic.route_hint': 'Pilih tujuan responden setelah tiap jawaban. Jawaban yang dibiarkan default lanjut ke pertanyaan berikutnya.',
  'logic.route_next': 'Pertanyaan berikutnya (default)',
  'logic.route_for': 'Tujuan untuk "{name}"',
  'logic.jump_title': 'Lompat ke pertanyaan setelahnya (opsional)',
  'qe.rich_hint': 'Teks ini memiliki format. Mengubahnya di sini menghapus formatnya; gunakan mode Pratinjau agar format tetap ada.',
  'logic.jump_when': 'Jika jawaban ini',
  'rich.toolbar': 'Format teks',
  'rich.align_left': "Rata kiri",
  'rich.align_center': "Rata tengah",
  'rich.align_right': "Rata kanan",
  'rich.align_justify': "Rata kiri-kanan (justify)",
  'rich.size_down': "Perkecil teks",
  'rich.size_up': "Perbesar teks",
  'rich.bold': 'Tebal',
  'rich.italic': 'Miring',
  'rich.underline': 'Garis bawah',
  'rich.bullets': 'Daftar poin',
  'rich.numbers': 'Daftar bernomor',
  'rich.link': 'Tambah tautan',
  'rich.clear': 'Hapus format',
  'rich.link_url': 'Alamat tautan',
  'rich.apply': 'Terapkan',
  'rich.link_invalid': 'Gunakan alamat yang diawali https://, http://, atau mailto:',
  'rich.placeholder_title': 'Ketik pertanyaan',
  'rich.placeholder_text': 'Ketik petunjuk',
  'rich.placeholder_desc': 'Tambah teks bantuan',
  'logic.jump_operator': 'Kondisi lompatan',
  'logic.jump_disabled': 'Jangan melompat',
  'logic.jump_to': 'lompat ke',
  'logic.jump_target': 'Tujuan lompatan',
  'logic.always_shown': 'Selalu ditampilkan. Tambahkan kondisi agar pertanyaan ini hanya muncul untuk sebagian responden.',
  'logic.show_when': 'Tampilkan pertanyaan ini jika',
  'logic.all': 'semua',
  'logic.any': 'salah satu',
  'logic.of_these': 'kondisi berikut terpenuhi:',
  'logic.match': 'Kecocokan',
  'logic.question': 'Pertanyaan',
  'logic.operator': 'Operator',
  'logic.value': 'Nilai',
  'logic.text_placeholder': 'Teks',
  'logic.missing_source': 'Pertanyaan hilang atau berada setelahnya',
  'logic.remove': 'Hapus kondisi',
  'logic.add': 'Tambah kondisi',
  'logic.row': 'Baris atau isian',
  'logic.whole_question': 'Seluruh pertanyaan',
  'logic.carried_hint': '(opsi dibawa dari pertanyaan sebelumnya)',
  'logic.jump_questions': 'Lompat ke pertanyaan',
  'logic.jump_endings': 'Akhiri survei',
  'logic.end_with': 'Akhiri: {name}',
  'logic.ending_hint': 'Responden langsung mengirim jawaban dan melihat pesan akhir ini.',
  'logic.endings_hint': 'Untuk mengakhiri survei lebih awal dengan pesan sendiri, tambahkan akhir survei di Pengaturan.',
  'flow.empty': 'Tambahkan pertanyaan untuk melihat alur survei.',
  'flow.q_ref': 'P{n}',
  'flow.shown_if': 'Tampil jika',
  'flow.help': 'Bagian ditampilkan dalam urutan ini. Tambahkan pengacak agar setiap responden hanya melihat sebagian dari sekelompok bagian.',
  'flow.show_section': 'Tampilkan bagian:',
  'flow.no_section': '(tanpa bagian)',
  'flow.n_questions': '({count} pertanyaan)',
  'flow.n_questions_one': '({count} pertanyaan)',
  'flow.toggle_questions': 'Tampilkan pertanyaan',
  'flow.add_below': 'Tambah di bawah',
  'flow.move_up': 'Naikkan',
  'flow.move_down': 'Turunkan',
  'flow.duplicate': 'Duplikat',
  'flow.rename': 'Ganti nama',
  'flow.delete': 'Hapus',
  'flow.add_what': "Apa yang ingin ditambahkan?",
  'flow.add_existing': "Bagian yang sudah ada",
  'flow.add_existing_here': "Pindahkan ke sini",
  'flow.add_branch': "Cabang",
  'flow.add_end': "Akhir survei",
  'flow.branch': "Cabang:",
  'flow.branch_if': "jika {q} {cond}, lanjut ke",
  'flow.branch_end': "akhir survei ({name})",
  'flow.branch_section': "bagian “{title}” ({q})",
  'flow.branch_remove': "Hapus cabang",
  'flow.branch_confirm_remove': "Hapus cabang ini?",
  'flow.branch_title': "Tambah cabang",
  'flow.branch_help': "Arahkan responden ke tempat lain sesuai jawabannya: ke pertanyaan berikutnya, bagian berikutnya, atau akhir survei. Responden lain lanjut berurutan.",
  'flow.end_title': "Akhiri survei di sini",
  'flow.end_help': "Responden yang jawabannya cocok langsung menyelesaikan survei dan melihat pesan penutup.",
  'flow.branch_when': "Jika jawaban untuk",
  'flow.branch_operator': "Kondisi",
  'flow.branch_then': "Lanjut ke",
  'flow.branch_to_section': "Bagian",
  'flow.branch_to_question': "Pertanyaan",
  'flow.branch_to_end': "Akhir survei",
  'flow.end_new': "Akhir survei (penutup baru)",
  'flow.end_default_name': "Akhir survei",
  'flow.end_default_message': "Terima kasih, survei ini telah selesai.",
  'flow.branch_choice_hint': "Tambahkan satu cabang per jawaban untuk mengarahkan tiap jawaban ke tempat berbeda.",
  'flow.more_actions': "Tindakan lain",
  'flow.ov_title': "Ringkasan",
  'flow.ov_sections': "Bagian",
  'flow.ov_questions': "Pertanyaan",
  'flow.ov_randomizers': "Pengacak",
  'flow.ov_branches': "Cabang",
  'flow.ov_endings': "Akhir survei",
  'flow.ov_how': "Cara kerja",
  'flow.ov_tip_order': "Responden berjalan dari atas ke bawah. Seret ⋮⋮ untuk mengubah urutan.",
  'flow.ov_tip_add': "Gunakan + untuk menambah bagian, cabang, pengacak, atau akhir survei di bawah elemen.",
  'flow.ov_tip_branch': "Cabang mengarahkan responden dengan jawaban tertentu ke pertanyaan, bagian berikutnya, atau akhir survei.",
  'flow.ov_tip_rz': "Pengacak hanya menampilkan sebagian bagiannya ke tiap responden, dalam urutan acak.",
  'flow.add_section': 'Bagian',
  'flow.add_randomizer': 'Pengacak',
  'flow.add_element': 'Tambah elemen baru di sini',
  'flow.randomizer': 'Pengacak',
  'flow.rz_present': 'Tampilkan secara acak',
  'flow.rz_of': 'dari {count} bagian berikut',
  'flow.rz_fewer': 'Kurangi satu bagian',
  'flow.rz_more': 'Tambah satu bagian',
  'flow.rz_empty': 'Pengacak ini masih kosong. Tambahkan bagian di bawah atau seret ke sini, lalu pilih berapa yang ditampilkan.',
  'flow.rz_evenly': 'Tampilkan elemen secara merata',
  'flow.rz_edit_counts': 'Ubah hitungan',
  'flow.rz_counts_title': 'Hitungan elemen',
  'flow.rz_counts_help': 'Batasi berapa responden yang mendapat tiap elemen. Kosongkan batas jika tidak dibatasi. Dengan "merata" aktif, elemen yang paling sedikit didapat responden ditampilkan lebih dulu.',
  'flow.rz_counts_section': 'Elemen',
  'flow.rz_counts_given_short': 'didapat',
  'flow.rz_counts_given': 'Sudah didapat',
  'flow.rz_counts_limit': 'Batas',
  'flow.rz_counts_none': 'Tanpa batas',
  'flow.rz_counts_limit_for': 'Batas untuk {title}',
  'flow.rz_counts_reset': 'Reset semua hitungan',
  'flow.rz_counts_clear': 'Hapus batas',
  'flow.rz_counts_failed': 'Hitungan tidak dapat dimuat.',
  'flow.rz_counts_note': "Setiap responden dihitung saat mulai mengisi survei, sehingga penampilan merata dan batas langsung berlaku. Publikasikan ulang setelah mengubah batas. Jika semua elemen sudah mencapai batas, yang paling mendekati batas tetap ditampilkan sehingga responden tidak pernah terhalang.",
  'flow.rz_evenly_hint': "Tampilkan berikutnya elemen yang paling sedikit didapat responden, agar semua elemen mendapat jumlah yang hampir sama.",
  'flow.rz_counts_total': "Total {n} didapat",
  'flow.rz_counts_full': "Penuh",
  'flow.rz_counts_reset_confirm': "Mulai semua hitungan dari 0 lagi? Respons yang sudah masuk tetap disimpan.",
  'flow.rz_counts_reset_pending': "Hitungan mulai dari 0 setelah Anda menyimpan dan memublikasikan.",
  'flow.rz_hint': 'Setiap responden melihat {n} dari bagian-bagian ini, dalam urutan acak. Biarkan bagian-bagian ini berdampingan.',
  'flow.rz_include_above': 'Masukkan “{title}” di atas',
  'flow.rz_include_below': 'Masukkan “{title}” di bawah',
  'flow.rz_take_out': 'Keluarkan',
  'flow.rz_remove': 'Hapus pengacak',
  'flow.rz_confirm_remove': 'Hapus pengacak ini? Bagiannya tetap ada dan setiap responden melihat semuanya.',
  'flow.confirm_delete_section': 'Hapus bagian “{title}” dan {count} pertanyaannya? Logika yang memakainya ikut dihapus.',
  'flow.name_untitled': 'Beri nama bagian ini',
  'flow.name_taken': 'Bagian lain sudah memakai nama ini.',
  'flow.rename_title': 'Ganti nama bagian',
  'flow.new_section_title': 'Bagian baru',
  'flow.open_new_tab': 'Buka di tab baru',
  'flow.leads': 'Jika jawabannya {cond}, menampilkan',
  'flow.carries_to': 'Membawa pilihannya ke',
  'flow.shuffled_with_logic': 'Diacak meskipun memiliki logika',
  'all.title': 'Semua pertanyaan',
  'all.device': 'Ukuran pratinjau',
  'all.device_desktop': 'Desktop',
  'all.device_tablet': 'Tablet',
  'all.device_mobile': 'Seluler',
  'all.section_name': 'Nama bagian',
  'all.rz_note': "Tampilan ini memuat semua pertanyaan. Responden hanya mendapat bagian yang dipilih pengacak; gunakan tab Pratinjau untuk mencobanya.",
  'all.hint': "Klik pertanyaan untuk mengeditnya di sini. Opsi lainnya ada di tab Pertanyaan di sebelah kiri.",
  'all.section_n': 'Bagian {n}',
  'all.no_section': 'Tanpa bagian',
  'all.no_section_hint': 'Belum ada bagian. Gunakan Tambah → Kelompokkan pertanyaan yang ada ke dalam bagian.',
  'all.editing': 'Sedang diubah',
  'all.randomizer': 'Pengacak {present}/{total}',
  'all.edit_question': 'Pertanyaan {n}: {title}. Pilih untuk mengubah pengaturannya.',
  'flow.and': 'dan',
  'flow.or': 'atau',
  'flow.jump_if': 'Jika jawaban {cond}, lompat ke',
  'flow.ends_if': 'Mengakhiri survei jika jawaban {cond}:',
  'flow.carries_selected': 'Opsi: yang dipilih di {q}',
  'flow.carries_not_selected': 'Opsi: yang tidak dipilih di {q}',
  'flow.loops': 'Bagian diulang untuk setiap opsi yang dipilih di {q}',

  'share.publishing': 'Penerbitan',
  'share.published_on': 'Versi {version} diterbitkan {date}',
  'share.not_published': 'Belum diterbitkan',
  'share.fix_before': 'Perbaiki hal berikut sebelum menerbitkan:',
  'share.live_has_changes': 'Responden masih melihat versi {version}. Terbitkan untuk merilis perubahan terbaru Anda.',
  'share.closed_note': 'Ditutup — tautan menampilkan halaman “tidak lagi menerima respons”.',
  'share.archived_note': 'Diarsipkan. Pulihkan dari daftar kuesioner untuk menerbitkan kembali.',
  'share.saving': 'Menyimpan…',
  'share.publish': 'Terbitkan',
  'share.publish_changes': 'Terbitkan perubahan',
  'share.up_to_date': 'Sudah terbaru',
  'share.reopen_publish': 'Buka kembali & terbitkan',
  'share.close_responses': 'Tutup pengumpulan respons',
  'share.requires_signin': 'Responden harus masuk',
  'share.anyone': 'Siapa pun yang memiliki tautan dapat mengisi',
  'share.copied': 'Tautan disalin',
  'share.copy_failed': 'Gagal menyalin — pilih tautan secara manual',
  'share.versions': 'Versi yang diterbitkan',
  'share.field_work': 'Pekerjaan lapangan',
  'share.team': 'Akses tim',
  'share.team_sub': 'Editor dapat menyusun dan menerbitkan; peninjau dapat melihat hasil dan mengekspor.',
  'share.owner': 'Pemilik',
  'share.remove': 'Hapus {email}',
  'share.invite': 'Undang melalui email',
  'share.invite_placeholder': 'rekan@perusahaan.com',
  'share.permission': 'Izin',
  'share.viewer': 'Peninjau',
  'share.editor': 'Editor',
  'share.invite_hint': 'Orang tersebut harus memiliki akun. Analis hanya dapat menjadi peninjau.',
  'share.granted': 'Akses diberikan',

  'runner.preview_unpublished': "Ada perubahan yang belum dilihat responden. Publikasikan perubahan agar berlaku di tautan survei.",
  'runner.preview_rz_off': "Pengacak {n} tidak diterapkan, jadi semua bagiannya ditampilkan:",
  'runner.preview_rz_picked': "Pengacak {n}: percobaan ini menampilkan {sections} ({present} dari {total} bagian). Mulai ulang untuk pilihan lain.",
  'runner.preview_rz_will': "Pengacak {n} menampilkan {present} dari {total} bagian ({sections}) ke tiap responden. Mulai untuk melihat bagian yang didapat percobaan ini.",
  'runner.preview_banner': 'Pratinjau — menampilkan perubahan terakhir yang tersimpan. Respons tidak dicatat.',
  'runner.restart': 'Mulai ulang',
  'runner.resumed': 'Anda melanjutkan jawaban yang sudah dimulai sebelumnya di perangkat ini.',
  'runner.start_over': 'Mulai dari awal',
  'runner.open_tab': 'Buka di tab baru',
  'runner.progress': 'Pertanyaan {n} dari {total}',
  'runner.page_progress': 'Halaman {n} dari {total}',
  'runner.question_n': 'Pertanyaan {n}',
  'runner.page_questions': '{count} pertanyaan',
  'runner.page_questions_one': '1 pertanyaan',
  'runner.eyebrow': 'Kuesioner',
  'runner.question_count': "{count} pertanyaan",
  'runner.question_count_one': '1 pertanyaan',
  'runner.start': 'Mulai',
  'runner.finish': 'Selesai',
  'runner.all_done': 'Semua sudah terjawab',
  'runner.submit_hint': 'Kirim untuk mencatat jawaban Anda. Anda dapat kembali untuk memeriksanya terlebih dahulu.',
  'runner.submitting': 'Mengirim…',
  'runner.finish_preview': 'Selesaikan pratinjau',
  'runner.submit': 'Kirim',
  'runner.preview_complete': 'Pratinjau selesai',
  'runner.thank_you': 'Terima kasih!',
  'runner.nothing_saved': 'Tidak ada yang disimpan.',
  'runner.recorded': 'Respons Anda telah tercatat.',
  'runner.run_again': 'Jalankan lagi',
  'runner.submit_failed': 'Gagal mengirim.',
  'runner.language': 'Bahasa',
  'runner.screened_title': 'Terima kasih atas waktu Anda',
  'runner.screened_body': 'Kami sudah memiliki cukup respons dari responden seperti Anda, jadi Anda tidak perlu melanjutkan.',
  'runner.redirecting': 'Mengarahkan Anda ke halaman berikutnya…',
  'runner.would_redirect': 'Responden akan diarahkan ke {url}.',
  'runner.continue': 'Lanjutkan',
  'captcha.load_failed': 'Verifikasi manusia gagal dimuat. Periksa koneksi lalu muat ulang halaman.',
  'captcha.failed': 'Verifikasi manusia gagal. Silakan kirim ulang.',
  'runner.time_spent': 'Waktu yang digunakan {time}',
  'runner.about': 'Tentang: {title}',
  'input.type_answer': 'Ketik jawaban Anda',
  'input.select_option': 'Pilih opsi…',
  'input.other_placeholder': 'Sebutkan',
  'input.slider_unset': 'Geser slider',
  'input.nps_low': 'Sangat tidak mungkin',
  'input.nps_high': 'Sangat mungkin',
  'input.sum_total': 'Total {sum} dari {total}',
  'input.sum_left': 'sisa {n}',
  'input.sum_over': 'kelebihan {n}',
  'input.file_choose': 'Pilih berkas',
  'input.file_uploading': 'Mengunggah…',
  'input.file_replace': 'Ganti',
  'input.file_remove': 'Hapus berkas',
  'input.file_hint': 'Foto, PDF, Word, Excel, PowerPoint, CSV, atau teks, maksimal {mb} MB.',
  'input.file_too_big': 'Ukuran berkas maksimal {mb} MB.',
  'input.file_failed': 'Gagal mengunggah. Coba lagi.',
  'input.sign_here': 'Tanda tangani di kotak di atas',
  'input.signed': 'Sudah ditandatangani',
  'input.sign_clear': 'Hapus',
  'input.location_share': 'Bagikan lokasi saya',
  'input.location_again': 'Perbarui lokasi',
  'input.location_locating': 'Mencari lokasi Anda…',
  'input.location_denied': 'Akses lokasi diblokir. Izinkan di pengaturan peramban lalu coba lagi.',
  'input.location_unavailable': 'Lokasi Anda belum tersedia saat ini.',
  'input.location_accuracy': 'akurasi {m} m',
  'input.location_view': 'Lihat peta',
  'input.location_clear': 'Hapus lokasi',
  'tip.more_info': 'Informasi lebih lanjut',

  'public.signed_in_as': 'Masuk sebagai {email}',
  'public.requires_signin_title': '“{title}” mewajibkan masuk',
  'public.signin_required': 'Harus masuk',
  'public.signin_body': 'Kuesioner ini hanya terbuka bagi responden terdaftar.',
  'public.create_account': 'Buat akun',
  'public.closed_title': 'Kuesioner ini sudah ditutup',
  'public.closed_body': 'Kuesioner ini tidak lagi menerima respons.',
  'public.missing_title': 'Kuesioner tidak ditemukan',
  'public.missing_body': 'Periksa tautan atau kode {code}.',
  'public.load_failed': 'Gagal memuat survei.',
  'public.offline_mode': 'Offline: survei tersimpan tersedia di perangkat ini. Respons baru akan menunggu sampai Anda kembali online.',
  'public.offline_queued': '{count} respons menunggu sinkronisasi dari perangkat ini.',
  'public.offline_failed': 'Respons yang diantrekan ditolak oleh server. Tinjau sebelum mencoba lagi atau menghapusnya.',
  'public.sync_now': 'Sinkronkan sekarang',
  'public.retry_failed': 'Coba ulang respons yang ditolak',
  'public.discard_failed': 'Hapus respons yang ditolak',

  'resp.export_csv': 'CSV',
  'resp.export_xlsx': 'Excel',
  'filter.from': 'Dari',
  'filter.to': 'Sampai',
  'filter.any': 'Semua',
  'filter.by_answer': 'Filter berdasarkan jawaban',
  'filter.responses_where': 'Respons dengan',
  'filter.include_test': 'Sertakan {count} respons uji',
  'filter.include_test_one': 'Sertakan 1 respons uji',
  'filter.weighted': 'Terbobot',
  'resp.view_summary': 'Ringkasan',
  'resp.view_crosstab': 'Tabulasi silang',
  'resp.view_list': 'Respons',
  'resp.test': 'Uji',
  'resp.no_match': 'Tidak ada respons yang cocok dengan filter',
  'resp.no_match_hint': 'Hapus atau longgarkan filter untuk melihat hasil.',
  'resp.print': 'Cetak / PDF',
  'resp.print_hint': 'Cetak dasbor atau simpan sebagai PDF dari dialog cetak',
  'resp.export': 'Ekspor',
  'resp.export_blocked': 'Setujui semua respons sebelum mengekspor',
  'resp.export_sav': 'SPSS (.sav)',
  'resp.export_csv_hint': 'Teks biasa, dapat dibuka di mana saja',
  'resp.export_xlsx_hint': 'Buku kerja Excel dengan kamus pertanyaan',
  'resp.export_sav_hint': 'Nilai berkode dengan label untuk SPSS, R, atau Stata',
  'resp.export_filter_note': 'Ekspor memakai filter dan pembobotan di atas.',
  'resp.weighted_n': 'terbobot {n}',
  'resp.score': 'Skor',
  'resp.score_sub': 'Rata-rata {mean} · dari {min} sampai {max}',
  'resp.endings': 'Akhir survei yang dicapai',
  'resp.ending': 'Akhir survei',
  'resp.nps_score': 'Net Promoter Score (−100 sampai +100)',
  'resp.nps_detractors': 'Pengkritik 0–6',
  'resp.nps_passives': 'Pasif 7–8',
  'resp.nps_promoters': 'Promotor 9–10',
  'resp.avg_rank': 'rata-rata peringkat {n}',
  'resp.avg_value': 'rata-rata {n}',
  'resp.rank_note': 'Lebih kecil lebih baik: 1 berarti peringkat pertama.',
  'resp.sum_note': 'Rata-rata jumlah yang diberikan untuk tiap item.',
  'resp.stat_mean': 'Rata-rata',
  'resp.stat_median': 'Median',
  'resp.stat_min': 'Terendah',
  'resp.stat_max': 'Tertinggi',
  'resp.terms_note': 'Kata yang paling sering muncul, tanpa kata umum seperti “the” dan “yang”.',
  'resp.no_chart': 'Lihat respons satu per satu untuk jawaban ini.',
  'resp.looped_note': 'setiap putaran dihitung',
  'resp.other_texts': 'Jawaban “Lainnya”',
  'resp.signature_alt': 'Tanda tangan responden',
  'resp.edit': 'Ubah jawaban',
  'resp.edit_title': 'Ubah respons',
  'resp.edit_note': 'Perubahan diperiksa terhadap kuesioner dan dicatat di log aktivitas.',
  'resp.edit_saved': 'Respons diperbarui.',
  'resp.edited': 'Terakhir diubah',
  'xtab.title': 'Tabulasi silang',
  'resp.randomizer_picks': 'Bagian yang ditampilkan (pengacak)',
  'xtab.sub': 'Bandingkan jawaban dua pertanyaan',
  'xtab.rows': 'Baris',
  'xtab.columns': 'Kolom',
  'xtab.swap': 'Tukar baris dan kolom',
  'xtab.show': 'Tampilkan',
  'xtab.mode_count': 'Jumlah',
  'xtab.mode_row': '% baris',
  'xtab.mode_col': '% kolom',
  'xtab.mode_total': '% total',
  'xtab.total': 'Total',
  'xtab.chi': 'Chi-kuadrat {stat}, df {df}, p {p}:',
  'xtab.significant': 'keduanya berhubungan (signifikan pada 5%).',
  'xtab.not_significant': 'tidak ada hubungan signifikan pada 5%.',
  'xtab.low_expected': 'Beberapa sel memiliki kurang dari 5 respons yang diharapkan, jadi gunakan uji ini dengan hati-hati.',
  'xtab.no_chi': 'Data belum cukup untuk uji chi-kuadrat.',
  'xtab.no_chi_multi': 'Tanpa uji chi-kuadrat: jawaban pilihan ganda masuk ke beberapa kolom sekaligus.',
  'xtab.multi_note': 'Jawaban pilihan ganda dihitung sekali per opsi yang dipilih, sehingga total bisa melebihi jumlah respons.',
  'xtab.need_two': 'Tabulasi silang memerlukan dua pertanyaan',
  'xtab.need_two_hint': 'Tambahkan pertanyaan pilihan, ya/tidak, penilaian, NPS, atau kolom tersembunyi untuk dibandingkan.',
  'tools.test_title': 'Respons uji',
  'tools.test_sub': 'Isi dasbor dengan data contoh yang realistis',
  'tools.test_count': 'Berapa banyak',
  'tools.test_generate': 'Buat',
  'tools.test_created': '{count} respons uji dibuat.',
  'tools.test_delete': 'Hapus {count} respons uji',
  'tools.test_delete_one': 'Hapus 1 respons uji',
  'tools.test_confirm_delete': 'Hapus semua {count} respons uji? Respons asli tidak terpengaruh.',
  'tools.test_deleted': '{count} respons uji dihapus.',
  'tools.test_hint': 'Respons uji mengikuti logika dan validasi Anda. Respons ini disembunyikan dari dasbor dan ekspor kecuali Anda menyertakannya, dan tidak dihitung dalam kuota.',
  'tools.test_publish_first': 'Terbitkan kuesioner untuk membuat respons uji.',
  'tools.weight_title': 'Pembobotan',
  'tools.weight_off': 'Belum diatur',
  'tools.weight_by': 'Dibobot berdasarkan {name}',
  'tools.weight_setup': 'Atur',
  'tools.weight_edit': 'Ubah',
  'tools.weight_hint': 'Pembobotan menyesuaikan hasil agar setiap kelompok dihitung sesuai porsinya di populasi, mis. 50% perempuan dan 50% laki-laki. Aktifkan di bilah filter.',
  'tools.weight_variable': 'Bobot berdasarkan',
  'tools.weight_variable_hint': 'Pertanyaan dengan satu jawaban per responden, atau kolom tersembunyi.',
  'tools.weight_sum': 'Total target {sum}%',
  'tools.weight_modal_hint': 'Masukkan porsi tiap kelompok di populasi. Kelompok bernilai 0 tidak dibobot.',
  'tools.weight_remove': 'Hapus pembobotan',
  'tools.weight_saved': 'Pembobotan disimpan.',
  'tools.weight_removed': 'Pembobotan dihapus.',
  'resp.exporting': 'Mengekspor…',
  'resp.downloaded': '{name} diunduh',
  'resp.export_failed': 'Ekspor gagal.',
  'resp.load_failed': 'Gagal memuat dasbor.',
  'resp.list_failed': 'Gagal memuat respons.',
  'resp.none_yet': 'Belum ada respons',
  'resp.share_to_collect': 'Bagikan {link} untuk mulai mengumpulkan respons.',
  'resp.publish_to_collect': 'Terbitkan kuesioner untuk mulai mengumpulkan respons.',
  'resp.all_responses': 'Semua respons',
  'resp.all_sub': 'Terbaru lebih dulu · klik baris untuk detail',
  'resp.col_submitted': 'Dikirim',
  'resp.col_source': 'Sumber',
  'resp.col_respondent': 'Responden',
  'resp.col_version': 'Versi',
  'resp.col_answered': 'Terjawab',
  'resp.col_time': 'Waktu',
  'resp.showing': 'Menampilkan {from}–{to} dari {total}',
  'resp.web': 'Web',
  'resp.mobile': 'Seluler',
  'resp.kpi_total': 'Total respons',
  'resp.kpi_channels': 'Web / seluler',
  'resp.kpi_avg': 'Rata-rata waktu',
  'resp.kpi_median': 'Median waktu',
  'resp.per_day': 'Respons per hari',
  'resp.per_day_sub': '14 hari terakhir · tersibuk {peak}',
  'resp.per_day_aria': 'Respons per hari selama 14 hari terakhir',
  'resp.day_tip': '{date}: {count}',
  'resp.day_aria': '{date}: {count} respons',
  'resp.channel': 'Kanal pengumpulan',
  'resp.channel_aria': 'Web {web}, seluler {mobile}',
  'resp.channel_note': 'Respons seluler termasuk yang direkam saat luring lalu disinkronkan.',
  'resp.answered_summary': '{answered} menjawab · {pct} dari respons',
  'resp.mean_summary': ' · rata-rata {mean} (min {min}, maks {max})',
  'resp.multi_note': 'Responden dapat memilih beberapa opsi; persentase dihitung dari yang menjawab.',
  'resp.numeric_note': 'Jawaban angka — lihat ringkasan di atas atau ekspor untuk distribusi lengkap.',
  'resp.text_note': 'Jawaban teks bebas tercantum per respons dan dalam ekspor.',
  'resp.drawer_title': 'Respons',
  'resp.received': 'Diterima',
  'resp.active_time': 'Waktu aktif',
  'resp.submission_id': 'ID pengiriman',
  'resp.skipped': '— dilewati —',

  'users.title': 'Pengguna & peran',
  'users.add': 'Tambah pengguna',
  'users.load_failed': 'Gagal memuat pengguna',
  'users.updated': 'Pengguna diperbarui',
  'users.update_failed': 'Gagal memperbarui',
  'users.accounts': 'Akun',
  'users.search_placeholder': 'Cari nama atau email',
  'users.search_label': 'Cari pengguna',
  'users.none': 'Tidak ada pengguna',
  'users.col_user': 'Pengguna',
  'users.col_role': 'Peran',
  'users.col_status': 'Status',
  'users.col_created': 'Dibuat',
  'users.role_for': 'Peran untuk {email}',
  'users.cant_change_own': 'Anda tidak dapat mengubah peran sendiri',
  'users.active': 'Aktif',
  'users.disabled': 'Nonaktif',
  'users.pending': 'Menunggu persetujuan',
  'users.disable': 'Nonaktifkan',
  'users.enable': 'Aktifkan',
  'users.created': 'Pengguna dibuat',
  'users.creating': 'Membuat…',
  'users.create': 'Buat pengguna',
  'users.temp_password': 'Kata sandi sementara',
  'users.temp_password_hint': 'Minimal 8 karakter. Minta pengguna menggantinya setelah masuk.',
  'users.role': 'Peran',

  // invitations
  'invitations.title': 'Undangan',
  'invitations.sub': 'Bagikan link pendaftaran dengan peran yang Anda pilih. Setiap pendaftar menunggu persetujuan Anda sebelum bisa masuk.',
  'invitations.add': 'Undangan baru',
  'invitations.create': 'Buat link',
  'invitations.creating': 'Membuat…',
  'invitations.created': 'Link undangan dibuat dan disalin',
  'invitations.label': 'Nama',
  'invitations.label_placeholder': 'mis. Tim lapangan Jakarta',
  'invitations.label_hint': 'Hanya Anda yang melihat ini, untuk membedakan antar-link.',
  'invitations.role_hint': 'Semua yang mendaftar lewat link ini mendapat peran ini.',
  'invitations.max_uses': 'Batas pemakaian',
  'invitations.max_uses_hint': 'Berapa kali link bisa dipakai mendaftar. Kosongkan jika tanpa batas.',
  'invitations.col_label': 'Undangan',
  'invitations.col_role': 'Peran',
  'invitations.col_uses': 'Terpakai',
  'invitations.col_pending': 'Menunggu',
  'invitations.col_status': 'Status',
  'invitations.unlimited': 'tanpa batas',
  'invitations.untitled': 'Link tanpa nama',
  'invitations.status_active': 'Aktif',
  'invitations.status_revoked': 'Dicabut',
  'invitations.status_full': 'Kuota habis',
  'invitations.copy_link': 'Salin link',
  'invitations.link_copied': 'Link disalin',
  'invitations.copy_failed': 'Gagal menyalin. Pilih dan salin link ini secara manual: {url}',
  'invitations.review': 'Tinjau pendaftar',
  'invitations.revoke': 'Cabut',
  'invitations.reactivate': 'Aktifkan lagi',
  'invitations.confirm_revoke': 'Cabut link ini? Tidak ada lagi yang bisa mendaftar lewat link ini. Pendaftar yang sedang menunggu tetap bisa disetujui.',
  'invitations.updated': 'Undangan diperbarui',
  'invitations.update_failed': 'Gagal memperbarui undangan',
  'invitations.load_failed': 'Gagal memuat undangan',
  'invitations.none': 'Belum ada link undangan',
  'invitations.none_hint': 'Buat link, pilih peran dan batas pemakaian, lalu bagikan.',
  'invitations.signups_title': 'Pendaftar: {label}',
  'invitations.signups_none': 'Belum ada yang mendaftar lewat link ini.',
  'invitations.select_all': 'Pilih semua yang menunggu',
  'invitations.approve_selected': 'Setujui yang dipilih',
  'invitations.reject_selected': 'Tolak yang dipilih',
  'invitations.approve_all': 'Setujui semua ({n})',
  'invitations.approved_n': '{n} pendaftar disetujui',
  'invitations.rejected_n': '{n} pendaftar ditolak',
  'invitations.confirm_reject': 'Tolak {n} pendaftar? Akun mereka dihapus dan mereka bisa diundang lagi.',
  'invitations.signup_waiting': 'Menunggu',
  'invitations.signup_approved': 'Disetujui',

  'account.title': 'Akun',
  'account.respondent_note':
    'Anda masuk sebagai responden. Buka tautan survei yang Anda terima untuk mengisinya, atau gunakan aplikasi seluler untuk survei lapangan. Administrator dapat memberi Anda akses untuk menyusun kuesioner atau melihat hasil.',
  'account.profile': 'Profil',
  'account.display_name': 'Nama tampilan',
  'account.updated': 'Profil diperbarui',
  'account.profile_hint': 'Beginilah tampilan Anda bagi tim.',
  'account.job_title': 'Jabatan',
  'account.job_title_placeholder': 'Misalnya, Kepala riset',
  'account.bio': 'Tentang Anda',
  'account.bio_placeholder': 'Satu-dua kalimat tentang pekerjaan Anda.',
  'account.banner': 'Banner',
  'account.banner.meadow': 'Padang',
  'account.banner.ocean': 'Samudra',
  'account.banner.sunset': 'Senja',
  'account.banner.dusk': 'Remang',
  'account.banner.rose': 'Mawar',
  'account.banner.slate': 'Batu',
  'account.banner.aurora': 'Aurora',
  'account.banner.sand': 'Pasir',
  'account.photo': 'Foto profil',
  'account.photo_hint': 'JPEG, PNG, atau WebP. Foto bisa diperbesar dan digeser.',
  'account.photo_upload': 'Unggah foto',
  'account.photo_change': 'Ganti foto',
  'account.photo_remove': 'Hapus foto',
  'account.photo_updated': 'Foto diperbarui',
  'account.photo_removed': 'Foto dihapus',
  'account.photo_failed': 'Foto tidak dapat diperbarui',
  'account.crop_title': 'Atur foto Anda',
  'account.crop_zoom': 'Perbesar',
  'account.crop_use': 'Pakai foto',
  'account.crop_hint': 'Seret untuk menggeser foto. Saat gambar difokuskan, gunakan tombol panah.',
  'account.crop_unreadable': 'Gambar ini tidak dapat dibaca. Coba JPEG, PNG, atau WebP.',
  'account.member_since': 'Anggota sejak {date}',
  'account.unsaved': 'Perubahan belum disimpan',
  'account.reset': 'Atur ulang',
  'account.access': 'Akses Anda',
  'account.access_hint': 'Yang dapat Anda lakukan dengan peran ini.',
  'account.access_more': '+{count} lainnya',
  'account.update_failed': 'Gagal memperbarui',
  'account.display': 'Tampilan',
  'account.display_hint': 'Pengaturan ini hanya berlaku di browser ini.',
  'account.accent_save': 'Simpan warna',
  'account.accent': "Warna aksen",
  'account.accent_light': "Mode terang",
  'account.accent_dark': "Mode gelap",
  'account.accent_default': "Bawaan",
  'account.accent_custom': "Warna kustom",
  'account.accent_custom_light': "Warna kustom untuk mode terang",
  'account.accent_custom_dark': "Warna kustom untuk mode gelap",
  'account.accent_hint': "Dipakai untuk sorotan, item terpilih, dan progres. Disimpan di akun Anda sehingga ikut di semua perangkat.",
  'account.accent_saved': "Warna aksen disimpan",
  'account.zoom': 'Zoom tata letak',
  'account.zoom_hint': 'Memperbesar atau memperkecil seluruh aplikasi. 100% adalah bawaan.',
  'account.sidebar': 'Bilah samping',
  'account.sidebar_expanded': 'Diperluas',
  'account.sidebar_collapsed': 'Diciutkan (hanya ikon)',
  'account.sidebar_hint': 'Anda juga bisa menciutkannya dengan tombol di bagian atas bilah samping. Di layar kecil bilah selalu terbuka sebagai laci.',
  'account.password': 'Kata sandi',
  'account.current_password': 'Kata sandi saat ini',
  'account.new_password': 'Kata sandi baru',
  'account.change_password': 'Ubah kata sandi',
  'account.password_changed': 'Kata sandi diubah',
  'account.language': 'Bahasa',
  'account.language_hint': 'Berlaku untuk browser ini. Isi kuesioner ditampilkan sesuai aslinya.',
  'respondents.title': 'Daftar responden',
  'respondents.subtitle': 'Peserta bernama untuk pengumpulan data lapangan. Gender dapat diperbaiki oleh administrator atau pembuat.',
  'respondents.add': 'Tambah responden',
  'respondents.search': 'Cari nama atau ID peserta',
  'respondents.name': 'Nama',
  'respondents.external_id': 'ID peserta (opsional)',
  'respondents.gender': 'Gender',
  'respondents.active': 'Aktif',
  'respondents.inactive': 'Tidak aktif',
  'respondents.female': 'Perempuan',
  'respondents.male': 'Laki-laki',
  'respondents.nonbinary': 'Nonbiner',
  'respondents.self_described': 'Deskripsi sendiri',
  'respondents.prefer_not_to_say': 'Memilih tidak menjawab',
  'respondents.unspecified': 'Belum ditentukan',
  'respondents.none': 'Belum ada responden',
  'respondents.create': 'Buat data',
  'respondents.save': 'Simpan perubahan',
  'respondents.created': 'Responden ditambahkan',
  'respondents.updated': 'Data responden diperbarui',
  'respondents.load_failed': 'Gagal memuat responden.',
  'respondents.assignments_title': 'Penugasan responden',
  'respondents.assignments_help': 'Tetapkan setiap responden kepada satu enumerator untuk survei ini.',
  'respondents.assignments_saved': 'Penugasan responden disimpan',
  'groups.title': 'Pengacakan kelompok',
  'groups.help': 'Acak responden survei ke kelompok dengan kuota tepat pada setiap strata gender.',
  'groups.stratify_by': 'Seimbangkan penugasan berdasarkan',
  'groups.gender': 'Gender',
  'groups.none': 'Tanpa strata',
  'groups.group': 'Kelompok',
  'groups.stratum': 'Strata',
  'groups.showing_first': 'Menampilkan {count} dari {total} penugasan pertama.',
  'groups.all_respondents': 'Semua responden',
  'groups.total': 'Total kuota',
  'groups.add': 'Tambah kelompok',
  'groups.randomize': 'Acak dan simpan penugasan',
  'groups.randomized': 'Penugasan kelompok diacak dan disimpan',
  'groups.assign_respondents_first': 'Tetapkan responden kepada enumerator sebelum mengacak kelompok.',
  'groups.lock_hint': 'Penugasan disimpan bersama survei dan disertakan dalam katalog mobile offline. Pengacakan tidak dapat diulang setelah respons pertama dikumpulkan.',
  'groups.load_failed': 'Gagal memuat data pengacakan kelompok.',
  'respondents.unassigned': 'Belum ditugaskan',
  'respondents.assigned_count': '{count} dari {total} ditugaskan',
  'approval.approve': 'Setujui',
  'approval.reject': 'Tolak',
  'approval.status': 'Persetujuan',
  'approval.pending': 'Menunggu',
  'approval.approved': 'Disetujui',
  'approval.rejected': 'Ditolak',
  'approval.survey_pending': 'Revisi menunggu persetujuan admin. Survei belum dapat dipublikasikan.',
  'approval.survey_approved': 'Revisi ini disetujui untuk dipublikasikan.',
  'approval.survey_rejected': 'Revisi ini ditolak. Ubah survei agar admin dapat memeriksa revisi baru.',
  'approval.response_approved': 'Respons disetujui',
  'approval.response_rejected': 'Respons ditolak',
  'approval.export_blocked': '{count} respons masih perlu persetujuan. Ekspor diblokir sampai semua respons disetujui.',
  'respondents.invalid_name': 'Masukkan nama maksimal 200 karakter.',
  'respondents.invalid_gender': 'Pilih nilai gender yang valid.',
  'enumerators.title': 'Penugasan enumerator',
  'enumerators.help': 'Hanya enumerator yang ditugaskan dapat mengunduh survei ini di aplikasi mobile dan menyinkronkan responsnya.',
  'enumerators.none': 'Belum ada akun enumerator aktif. Tambahkan akun enumerator terlebih dahulu.',
  'enumerators.save': 'Simpan penugasan',
  'enumerators.saved': 'Penugasan enumerator disimpan',
  'enumerators.load_failed': 'Gagal memuat penugasan enumerator.',
  'enumerators.selected': '{count} dari {total} dipilih',
  'enumerators.too_many': 'Maksimal 500 enumerator dapat ditugaskan ke satu survei.',
  'enumerators.invalid_list': 'Daftar enumerator berisi pengguna tidak valid atau duplikat.',
  'enumerators.user_unavailable': 'Satu atau beberapa akun pilihan tidak aktif atau bukan lagi enumerator.',
  'enumerators.survey_not_assigned': 'Survei ini tidak ditugaskan ke akun enumerator Anda.',

  // Asisten AI
  'assistant.open': 'Tanya asisten',
  'assistant.title': 'Asisten',
  'assistant.new_chat': 'Obrolan baru',
  'assistant.placeholder': 'Tanyakan tentang kuesioner atau hasil Anda…',
  'assistant.send': 'Kirim',
  'assistant.stop': 'Hentikan',
  'assistant.intro': 'Saya dapat mencari kuesioner dan hasil Anda, serta menyusun draf pertanyaan untuk Anda tinjau. Saya hanya melihat apa yang dapat Anda lihat, dan tidak pernah menyimpan apa pun tanpa persetujuan Anda.',
  'assistant.suggest_results': 'Ringkas hasil kuesioner ini',
  'assistant.suggest_improve': 'Bagaimana kuesioner ini bisa diperbaiki?',
  'assistant.suggest_text': 'Tema apa yang muncul dalam jawaban tertulis?',
  'assistant.suggest_list': 'Kuesioner mana yang paling banyak responsnya?',
  'assistant.suggest_new': 'Buat draf survei kepuasan pelanggan singkat',
  'assistant.working': 'Sedang berpikir…',
  'assistant.tool.list_surveys': 'Mencari kuesioner…',
  'assistant.tool.get_survey': 'Membaca kuesioner…',
  'assistant.tool.get_results': 'Membaca hasil…',
  'assistant.tool.list_variables': 'Memeriksa yang dapat dibandingkan…',
  'assistant.tool.crosstab': 'Membuat tabulasi silang…',
  'assistant.tool.response_trend': 'Memeriksa respons dari waktu ke waktu…',
  'assistant.tool.describe': 'Menghitung statistik…',
  'assistant.tool.compare_groups': 'Membandingkan kelompok…',
  'assistant.tool.drivers': 'Mencari yang berkaitan dengan hasil…',
  'assistant.tool.data_quality': 'Memeriksa kualitas respons…',
  'assistant.tool.field_progress': 'Memeriksa kemajuan lapangan…',
  'assistant.tool.compare_surveys': 'Membandingkan kuesioner…',
  'assistant.suggest_trend': 'Bagaimana tren respons dari waktu ke waktu?',
  'assistant.suggest_quality': 'Periksa kualitas respons',
  'assistant.sources': 'Sumber ({count})',
  'assistant.source_responses': '{count} respons',
  'assistant.source_responses_one': '{count} respons',
  'assistant.chart.data': 'Tampilkan data',
  'assistant.chart.category': 'Kategori',
  'assistant.tool.get_text_answers': 'Membaca jawaban tertulis…',
  'assistant.tool.propose_question_changes': 'Menyusun perubahan…',
  'assistant.tool.propose_new_survey': 'Menyusun kuesioner…',
  'assistant.proposal_edit': 'Usulan perubahan untuk “{title}”',
  'assistant.proposal_create': 'Kuesioner baru: “{title}”',
  'assistant.proposal_counts': '{added} ditambah · {updated} diubah · {removed} dihapus',
  'assistant.proposal_questions': '{count} pertanyaan',
  'assistant.proposal_questions_one': '{count} pertanyaan',
  'assistant.preview': 'Tampilkan pertanyaan',
  'assistant.apply': 'Terapkan',
  'assistant.dismiss': 'Abaikan',
  'assistant.applied': 'Diterapkan',
  'assistant.dismissed': 'Diabaikan',
  'assistant.apply_conflict': 'Kuesioner berubah setelah draf ini dibuat. Tanyakan lagi untuk usulan baru.',
  'assistant.created': 'Kuesioner dibuat.',
  'assistant.updated': 'Perubahan diterapkan.',
  'assistant.failed': 'Asisten tidak dapat menjawab. Silakan coba lagi.',
  'nav.assistant': 'Asisten',
  'assistant.open_full': 'Buka halaman penuh',
  'assistant.page_heading': 'Apa yang ingin Anda ketahui?',
  'assistant.chats': 'Obrolan terbaru',
  'assistant.no_chats': 'Obrolan Anda muncul di sini. Obrolan hanya disimpan di browser ini.',
  'assistant.delete_chat': 'Hapus obrolan',
  'assistant.turned_off': 'Administrator mematikan asisten AI untuk ruang kerja ini.',
  'settings.title': 'Pengaturan',
  'settings.sub': 'Opsi untuk seluruh ruang kerja. Perubahan langsung berlaku untuk semua pengguna.',
  'settings.saved': 'Pengaturan disimpan',
  'settings.assistant': 'Asisten AI',
  'settings.assistant_enabled': 'Aktifkan asisten AI dan chat',
  'settings.assistant_hint': 'Jika dimatikan, menu Asisten dan panel chat disembunyikan untuk semua orang dan server menolak permintaan chat.',
  'settings.assistant_demo': 'Belum ada model AI yang terhubung: server menjalankan demo berbasis aturan. Atur ASSISTANT_* di server untuk menghubungkan model.',
  'settings.assistant_not_configured': 'Belum ada model AI yang dikonfigurasi di server ini, jadi sakelar ini belum berpengaruh sampai ASSISTANT_* diatur.',
  'assistant.not_enabled': 'Asisten AI belum disiapkan di server ini. Administrator dapat mengaktifkannya dengan pengaturan ASSISTANT_*.',
  'assistant.suggest_compare': 'Bandingkan jawaban antarkelompok di kuesioner terbaru saya',
  'assistant.setup_intro': 'Untuk mengaktifkannya, tambahkan pengaturan ini ke environment API (api/.env secara lokal, /etc/survey/env atau pengaturan deploy GitHub di produksi):',
  'assistant.setup_after': 'Lalu mulai ulang API (./run.sh secara lokal) dan muat ulang halaman ini.',
  'assistant.demo_banner': 'Mode demo: belum ada model AI yang terhubung. Jawaban mengikuti aturan sederhana tetapi memakai data Anda yang sebenarnya. Atur ASSISTANT_* di server untuk menghubungkan model.',
  'assistant.disclaimer': 'AI bisa keliru. Periksa angka penting di dasbor.',
  'tabs.invites': 'Undangan',
  'public.invite_hello': 'Halo {name}, terima kasih sudah berpartisipasi.',
  'public.closes_on': 'Dibuka sampai {date}.',
  'public.not_open_title': 'Kuesioner ini belum dibuka',
  'public.not_open_body': 'Kuesioner dibuka pada {date}. Silakan kembali nanti.',
  'public.not_open_soon': 'Kuesioner akan segera dibuka. Silakan kembali nanti.',
  'public.invite_required_title': 'Khusus undangan',
  'public.invite_required_body': 'Buka kuesioner ini lewat link pribadi dari email undangan Anda.',
  'public.invite_invalid_title': 'Link undangan tidak dikenali',
  'public.invite_invalid_body': 'Pastikan Anda memakai link lengkap dari email undangan, atau minta link baru ke penyelenggara.',
  'public.invite_used_title': 'Sudah diisi',
  'public.invite_used_body': 'Undangan ini sudah dipakai untuk mengisi kuesioner. Terima kasih!',
  'progress.kpi_responses': 'Respons',
  'progress.kpi_today': 'Hari ini',
  'progress.kpi_active': 'Enumerator aktif hari ini',
  'progress.kpi_invites': 'Undangan terisi',
  'progress.kpi_channels': 'Web / mobile',
  'progress.per_day': 'Respons per hari',
  'progress.per_day_sub': '{days} hari terakhir, semua kanal',
  'progress.quotas': 'Kuota',
  'progress.quotas_close': 'Survei ditutup otomatis saat semua kuota penuh.',
  'progress.invites': 'Undangan',
  'progress.invites_sent': 'Terkirim',
  'progress.invites_opened': 'Dibuka',
  'progress.invites_completed': 'Terisi',
  'progress.auto_closed_schedule': 'Ditutup otomatis pada waktu tutupnya ({date}).',
  'progress.auto_closed_max_responses': 'Ditutup otomatis setelah mencapai batas respons ({date}).',
  'progress.auto_closed_quotas_full': 'Ditutup otomatis setelah semua kuota penuh ({date}).',
  'progress.opens_on': 'Dibuka {date}',
  'progress.closes_on': 'Ditutup {date}',
  'progress.no_enumerators': 'Belum ada enumerator',
  'progress.no_enumerators_body': 'Tugaskan enumerator di Publikasi & bagikan untuk memantau kerja lapangan mereka di sini.',
  'progress.enumerators': 'Enumerator',
  'progress.enumerators_sub': 'Respons per hari selama {days} hari terakhir, responden yang selesai, dan upload terakhir dari tiap perangkat',
  'progress.col_enumerator': 'Enumerator',
  'progress.col_total': 'Total',
  'progress.col_respondents': 'Responden selesai',
  'progress.col_review': 'Disetujui · ditolak',
  'progress.col_last_upload': 'Upload terakhir',
  'progress.approved': 'Disetujui',
  'progress.rejected': 'Ditolak',
  'progress.never': 'Belum pernah',
  'invites.reminders_queued': '{count} pengingat sedang dikirim.',
  'invites.reminders_queued_one': '1 pengingat sedang dikirim.',
  'invites.emails_queued': '{count} undangan sedang dikirim.',
  'invites.emails_queued_one': '1 undangan sedang dikirim.',
  'invites.nothing_to_send': 'Tidak ada yang perlu dikirimi: semua yang dipilih sudah dikirimi email atau sudah mengisi.',
  'invites.remove_confirm': 'Hapus {count} undangan? Link-nya tidak akan berfungsi lagi.',
  'invites.remove_confirm_one': 'Hapus undangan ini? Link-nya tidak akan berfungsi lagi.',
  'invites.removed': '{count} undangan dihapus.',
  'invites.removed_one': '1 undangan dihapus.',
  'invites.download_csv': 'Unduh link (CSV)',
  'invites.add': 'Tambah responden',
  'invites.email_off': 'Email belum diatur di server ini, jadi undangan belum bisa dikirim lewat email. Anda tetap bisa menambahkan orang dan membagikan link pribadinya (salin satu per satu, atau unduh semuanya sebagai CSV).',
  'invites.publish_first': 'Terbitkan kuesioner sebelum mengirim undangan lewat email.',
  'invites.mode_invite_only': 'Khusus undangan: responden web harus memakai link pribadinya untuk mengisi.',
  'invites.mode_open': 'Siapa pun dengan link publik bisa mengisi. Link pribadi juga mencatat siapa yang sudah mengisi dan hanya bisa dipakai sekali.',
  'invites.change_mode': 'Ubah',
  'invites.empty_title': 'Belum ada undangan',
  'invites.empty_body': 'Tambahkan responden lewat email. Masing-masing mendapat link pribadi yang hanya bisa dipakai sekali, dan Anda bisa mengirim pengingat ke yang belum mengisi.',
  'invites.status_total': 'Semua',
  'invites.status_new': 'Belum dikirim',
  'invites.status_queued': 'Mengirim',
  'invites.status_sent': 'Terkirim',
  'invites.status_opened': 'Dibuka',
  'invites.status_completed': 'Terisi',
  'invites.status_failed': 'Gagal',
  'invites.selected': '{count} dipilih',
  'invites.send': 'Kirim undangan',
  'invites.remind': 'Kirim pengingat',
  'invites.remove': 'Hapus',
  'invites.send_all_new': 'Kirim ke semua yang belum dikirimi ({count})',
  'invites.remind_all': 'Ingatkan semua yang belum mengisi',
  'invites.select_all': 'Pilih semua',
  'invites.col_person': 'Responden',
  'invites.col_status': 'Status',
  'invites.col_emailed': 'Dikirim',
  'invites.col_answered': 'Diisi',
  'invites.reminded': '{count} pengingat',
  'invites.reminded_one': '1 pengingat',
  'invites.opened_at': 'Dibuka {when}',
  'invites.copy_link': 'Salin link pribadi',
  'invites.added': '{added} ditambahkan, {skipped} sudah diundang sebelumnya.',
  'invites.invalid_emails': 'Bukan alamat email yang valid: {list}',
  'invites.add_title': 'Tambah responden',
  'invites.add_count': 'Tambah {count}',
  'invites.add_count_one': 'Tambah 1',
  'invites.paste_label': 'Alamat email',
  'invites.paste_hint': 'Satu per baris, boleh dengan nama: “ana@example.com, Ana” atau “Ana <ana@example.com>”. Bisa langsung tempel dari spreadsheet.',
  'invites.send_now': 'Kirim email undangan sekarang',
  'invites.send_now_unavailable': 'Email belum bisa dikirim (email belum diatur, atau kuesioner belum diterbitkan). Link bisa dibagikan manual.',
  'collection.saved': 'Jadwal disimpan',
  'collection.title': 'Jadwal & batas',
  'collection.help': 'Kapan respons diterima, kapan survei tertutup otomatis, dan siapa yang boleh mengisi.',
  'collection.opens_at': 'Dibuka pada',
  'collection.opens_hint': 'Kosong: langsung dibuka begitu diterbitkan.',
  'collection.closes_at': 'Ditutup pada',
  'collection.closes_hint': 'Kosong: tetap terbuka sampai ditutup manual.',
  'collection.max_responses': 'Tutup setelah jumlah respons',
  'collection.max_responses_hint': 'Respons uji coba tidak dihitung.',
  'collection.no_limit': 'Tanpa batas',
  'collection.close_on_quotas': 'Tutup saat semua kuota penuh',
  'collection.close_on_quotas_none': 'Tutup saat semua kuota penuh (tambahkan kuota di Pengaturan dulu)',
  'collection.invite_only': 'Khusus undangan (responden web butuh link pribadi)',
  'collection.reminder_days': 'Ingatkan undangan yang belum diisi tiap (hari)',
  'collection.reminder_hint': 'Kosong: tanpa pengingat otomatis.',
  'collection.reminder_no_email': 'Perlu pengaturan email di server.',
  'collection.no_reminders': 'Mati',
  'collection.max_reminders': 'Maksimal (pengingat)',
  'collection.unsaved': 'Ada perubahan belum disimpan',
  'collection.save': 'Simpan jadwal',
  'invitations.expired_on': 'Kedaluwarsa {date}',
  'invitations.expires_on': 'Berlaku sampai {date}',
  'invitations.joins': 'Masuk ke: {list}',
  'invitations.status_expired': 'Kedaluwarsa',
  'invitations.edit': 'Ubah',
  'invitations.edit_title': 'Ubah undangan',
  'invitations.save': 'Simpan',
  'invitations.expires_at': 'Berlaku sampai',
  'invitations.expires_hint': 'Link berhenti berfungsi pada waktu ini. Kosongkan jika tanpa batas waktu.',
  'invitations.surveys': 'Masukkan ke kuesioner saat di-approve',
  'invitations.surveys_hint_enumerator': 'Enumerator yang di-approve langsung ditugaskan ke kuesioner ini.',
  'invitations.surveys_hint_other': 'Orang yang di-approve langsung mendapat akses ke kuesioner ini sebagai viewer atau editor.',
  'invitations.surveys_none': 'Belum ada kuesioner.',
  'invitations.access_viewer': 'Viewer',
  'invitations.access_editor': 'Editor',
  'tabs.field': 'Lapangan',
  'field.nav_progress': 'Progres',
  'field.nav_assignments': 'Penugasan',
  'field.search_enumerators': 'Cari enumerator',
  'field.search_respondents': 'Cari nama atau ID',
  'field.no_match': 'Tidak ada yang cocok.',
  'field.unsaved': 'ada perubahan belum disimpan',
  'field.filter_all': 'Semua',
  'field.filter_unassigned': 'Belum ditugaskan',
  'field.filter_assigned': 'Sudah ditugaskan',
  'field.filter_enumerator': 'Saring per enumerator',
  'field.any_enumerator': 'Semua enumerator',
  'field.picked_one': '1 dipilih',
  'field.picked': '{count} dipilih',
  'field.assign_to': 'Tugaskan ke',
  'field.assign_picked': 'Tugaskan',
  'field.unassign_picked': 'Lepas penugasan',
  'field.clear_pick': 'Batal pilih',
  'field.pick_page': 'Pilih semua di halaman ini',
  'field.external_id': 'ID',
  'field.enumerator': 'Enumerator',
  'field.enumerator_for': 'Enumerator untuk {name}',
  'field.unknown_enumerator': 'Enumerator tidak tersedia',
  'field.changed_one': '1 perubahan belum disimpan',
  'field.changed': '{count} perubahan belum disimpan',
  'field.prev_page': 'Halaman sebelumnya',
  'field.next_page': 'Halaman berikutnya',
  'field.page_of': '{page} / {pages}',
  'groups.summary_one': '{groups} kelompok · 1 responden',
  'groups.summary': '{groups} kelompok · {count} responden',
  'groups.not_yet': 'Belum diacak',
  'builder.general': 'Umum',
  'builder.messages': 'Pesan',
  'settings.endings_count_one': '1 akhir tambahan',
  'settings.endings_count': '{count} akhir tambahan',
  'settings.endings_none_short': 'Semua responden melihat pesan terima kasih',
  'settings.quotas_none_short': 'Belum ada kuota',
  'settings.quota_no_conditions': 'Belum ada kondisi',
  'settings.quota_or': 'atau',
  'settings.none_short': 'Tidak ada',
  'settings.loops_count_one': '1 bagian berulang',
  'settings.loops_count': '{count} bagian berulang',
  'settings.theme_custom': 'Tampilan khusus',
  'settings.theme_default_short': 'Warna dan huruf bawaan',
  'collection.sum_opens': 'Buka {date}',
  'collection.sum_opened': 'Dibuka {date}',
  'collection.sum_closes': 'Tutup {date}',
  'collection.sum_no_close': 'Tanpa tanggal tutup',
  'collection.sum_max': 'Maks {n} respons',
  'collection.sum_quotas': 'Tutup saat kuota penuh',
  'collection.sum_invite_only': 'Khusus undangan',
  'collection.sum_reminders': 'Pengingat tiap {n} hari',
  'collection.auto_closed_badge': 'Ditutup otomatis',
  'share.code_short': 'Kode {code}',
  'share.field_work_moved': 'Enumerator, penugasan responden, dan kelompok sekarang ada di tab Lapangan.',
  'share.link_title': 'Tautan & kode QR',
  'share.link_sub': 'Beri tautan nama yang mudah diingat, atau biarkan orang memindai kode.',
  'share.custom_link': 'Tautan khusus',
  'share.slug_placeholder': 'survei-pelanggan-2026',
  'share.slug_hint': 'Kosongkan untuk memakai kode acak.',
  'share.slug_invalid': 'Gunakan {min} sampai {max} huruf kecil atau angka, dengan tanda hubung tunggal di antaranya.',
  'share.slug_saved': 'Tautan khusus disimpan',
  'share.slug_removed': 'Tautan khusus dihapus',
  'share.slug_remove': 'Hapus tautan khusus',
  'share.code_still_works': 'Tautan asli {link} tetap berfungsi.',
  'share.qr_title': 'Kode QR',
  'share.qr_alt': 'Kode QR yang membuka {link}',
  'share.qr_hint': 'Pindai untuk membuka kuesioner. Unduh untuk poster, brosur, atau layar.',
  'share.qr_logo': 'Taruh logo YellowMetrics di tengah',
  'share.copy_link': 'Salin tautan',
  'share.versions_sub_one': 'v{version} · {date}',
  'share.versions_sub': '{count} versi · terbaru v{version} · {date}',
  'builder.settings_search': 'Cari pengaturan, mis. captcha, kuota, bahasa',
  'builder.settings_found_one': '1 bagian cocok',
  'builder.settings_found': '{count} bagian cocok',
  'builder.settings_none': 'Tidak ada pengaturan yang cocok',
  'tabs.activity': 'Aktivitas',
  'resp.answers_note': 'Jawaban apa adanya, yang paling sering muncul di atas.',
  'resp.answers_more': 'Menampilkan {shown} jawaban teratas dari {total} jawaban berbeda. Ekspor untuk melihat semuanya.',
};
